import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { NotificationManager } from 'react-notifications';
import { NavigationContext } from '../../context/navigation-context';
import useFetch from '../../hooks/fetchMSSQL-hook';
import SearchFilter from '../../components/Filter/SearchFilter';
import { Button, Dropdown } from 'react-bootstrap';
const Nexgo = () => {
  const { setHeaderData } = useContext(NavigationContext);
  const { fetchMssqlApi } = useFetch();

  const [terminals, setTerminals] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [devices, setDevices] = useState([]);
  const [devicesModels, setDevicesModels] = useState([]);
  const [configurations, setConfigurations] = useState([]);
  const [availableDevices, setAvailableDevices] = useState([]);
  const [isRefreshingAllCache, setIsRefreshingAllCache] = useState(false);

  const processingStatuses = ['PENDING', 'PROCESSING', 'DOWNLOADING', 'REQUESTED', 'QUEUED', 'IN_PROGRESS', 'IN PROGRESS', 'INSTALLING', 'PUBLISHING', 'ENROLLING'];
  const isProcessingStatus = value => processingStatuses.includes(String(value || '').toUpperCase());
  const isTerminalProcessing = terminal => [
    terminal?.status?.status,
    terminal?.status?.enrollment?.status,
    terminal?.status?.downloading?.status
  ].some(isProcessingStatus);

  const getStatusBadgeClass = (value) => {
    const status = String(value || '').toUpperCase();
    if (['READY', 'SUCCESS', 'ENROLLED', 'ACTIVE'].includes(status)) {return 'badge badge-success'}
    if (isProcessingStatus(status)) {return 'badge badge-warning'}
    if (['FAILED', 'FAILURE', 'ERROR', 'NOT_ENROLLED', 'UNENROLLED'].includes(status)) {return 'badge badge-danger'}
    return 'badge badge-secondary';
  };
  const formatTs = (ts) => {
    if (!ts) return '-';
    if (typeof ts === 'string' && Number.isNaN(Number(ts))) {const date = new Date(ts); if (!Number.isNaN(date.getTime())) return date.toLocaleString('pl-PL'); return ts;}
    const n = Number(ts); if (Number.isNaN(n)) return String(ts);
    const date = new Date(n); if (Number.isNaN(date.getTime())) return String(ts);
    return date.toLocaleString('pl-PL');
  };
  const normalize = (value) => String(value || '').toLowerCase().trim();
  const getTerminalSn = terminal => terminal?.sn || terminal?.bindSN || ''


  const getTerminal = (tid, add = false, onLoad = null) => {
    fetchMssqlApi('nexgo/terminal/get', {method: 'POST', data: {tid}, hideNotification: true},
      response => {
        const terminal = response?.data?.item || response?.data
        if (!terminal?.tid) {
          if (onLoad) onLoad(null)
          return
        }
        setTerminals(prev => add
          ? [terminal, ...prev.filter(t => String(t?.tid) !== String(tid))]
          : prev.map(t => String(t?.tid) === String(tid) ? terminal : t)
        )
        if (onLoad) onLoad(terminal)
      },
      () => {if (onLoad) onLoad(null)}
    )
  }

  const notifyTerminalAction = (response, tid, successMessage, processingMessage) => {
    if (response?.processing) {
      NotificationManager.info(processingMessage || `Terminal ${tid} nadal przetwarza zmianę.`, 'W toku')
    } else {
      NotificationManager.success(successMessage, 'Sukces')
    }
    getTerminal(tid)
  }

  const handleTerminalActionError = (tid, errorMessage) => {
    setTimeout(() => {
      getTerminal(tid, false, terminal => {
        if (terminal && isTerminalProcessing(terminal)) {
          NotificationManager.info(`Terminal ${tid} nadal przetwarza zmianę.`, 'W toku')
        } else {
          NotificationManager.error(errorMessage, 'Błąd')
        }
      })
    }, 750)
  }


  const refreshTerminalCache = t => {
    fetchMssqlApi('nexgo/cache/terminal', {method: 'POST', hideNotification: true, data: {tid: t?.tid}},
      () => {
        NotificationManager.success(`Odświeżono ${t?.tid}.`, 'Sukces')
        getTerminal(t?.tid)
      },
      () => NotificationManager.error('Nie udało się odświeżyć cache.', 'Błąd')
    )
  }

  const refreshAllCache = () => {
    if (isRefreshingAllCache) return

    setIsRefreshingAllCache(true)

    fetchMssqlApi('nexgo/cache/all', {method: 'POST', hideNotification: true},
      () => {
        setIsRefreshingAllCache(false)
        NotificationManager.info('Rozpoczęto odświeżanie całego cache.', 'W toku')
      },
      () => {
        setIsRefreshingAllCache(false)
        NotificationManager.error('Nie udało się uruchomić odświeżania cache.', 'Błąd')
      }
    )
  }

  // Dane terminala PayOne
  const [terminalDetails, setTerminalDetails] = useState(null);
  const [terminalDetailsForm, setTerminalDetailsForm] = useState(null);
  const [isSavingTerminalDetails, setIsSavingTerminalDetails] = useState(false);

  const openTerminalDetailsModal = terminal => {
    if (!terminal?.tid) return;

    fetchMssqlApi('nexgo/terminal/get', {method: 'POST', hideNotification: true, data: {tid: terminal.tid}},
      response => {
        const data = response?.data?.item ?? response?.data;

        if (!data?.tid) {
          NotificationManager.error('Nie udało się pobrać danych terminala.', 'Błąd');
          return;
        }

        setTerminalDetails(data);
        setTerminalDetailsForm({
          tid: data?.tid ?? '',
          mid: data?.mid ?? '',
          sn: data?.sn ?? data?.bindSN ?? '',
          processorTid: data?.processorTid ?? '',
          processorMid: data?.processorMid ?? '',
          mcc: data?.mcc ?? '',
          currencyCode: data?.currencyCode ?? '',
          countryCode: data?.countryCode ?? '',
          address: {
            street: data?.address?.street ?? '',
            zipCode: data?.address?.zipCode ?? '',
            city: data?.address?.city ?? '',
            district: data?.address?.district ?? '',
            country: data?.address?.country ?? data?.address?.coutry ?? 'PL'
          },
          auth: {
            cards: {
              enabled: data?.auth?.cards?.enabled ?? false,
              tid: data?.auth?.cards?.tid ?? ''
            },
            blik: {
              enabled: data?.auth?.blik?.enabled ?? false,
              tid: data?.auth?.blik?.tid ?? ''
            }
          },
          otp: data?.passwords?.otp ?? data?.otp ?? '',
          adminPass: data?.passwords?.admin ?? data?.adminPass ?? '',
          techPass: data?.passwords?.tech ?? data?.techPass ?? ''
        });
      },
      () => NotificationManager.error('Nie udało się pobrać danych terminala.', 'Błąd')
    );
  };

  const closeTerminalDetailsModal = () => {
    setTerminalDetails(null);
    setTerminalDetailsForm(null);
    setIsSavingTerminalDetails(false);
  };

  const changeTerminalDetails = (field, value) => {
    setTerminalDetailsForm(prev => {
      if (!prev) return prev;

      if (field.startsWith('address.')) {
        const key = field.replace('address.', '');
        return {...prev, address: {...prev.address, [key]: value}};
      }

      if (field.startsWith('auth.cards.')) {
        const key = field.replace('auth.cards.', '');
        return {...prev, auth: {...prev.auth, cards: {...prev.auth.cards, [key]: value}}};
      }

      if (field.startsWith('auth.blik.')) {
        const key = field.replace('auth.blik.', '');
        return {...prev, auth: {...prev.auth, blik: {...prev.auth.blik, [key]: value}}};
      }

      return {...prev, [field]: value};
    });
  };

  const saveTerminalDetails = () => {
    if (!terminalDetailsForm?.tid) {
      NotificationManager.error('Brak TID terminala.', 'Błąd');
      return;
    }

    const payload = {
      tid: String(terminalDetailsForm.tid ?? '').trim(),
      processorMid: String(terminalDetailsForm.processorMid ?? '').trim(),
      mcc: String(terminalDetailsForm.mcc ?? '').trim(),
      address: {
        street: String(terminalDetailsForm.address?.street ?? '').trim(),
        zipCode: String(terminalDetailsForm.address?.zipCode ?? '').trim(),
        city: String(terminalDetailsForm.address?.city ?? '').trim(),
        district: String(terminalDetailsForm.address?.district ?? '').trim(),
        country: String(terminalDetailsForm.address?.country ?? '').trim()
      },
      auth: {
        cards: {
          enabled: terminalDetailsForm.auth?.cards?.enabled ?? false,
          tid: String(terminalDetailsForm.auth?.cards?.tid ?? '').trim()
        },
        blik: {
          enabled: terminalDetailsForm.auth?.blik?.enabled ?? false,
          tid: String(terminalDetailsForm.auth?.blik?.tid ?? '').trim()
        }
      }
    };

    if (terminalDetailsForm.currencyCode !== null && terminalDetailsForm.currencyCode !== undefined && String(terminalDetailsForm.currencyCode) !== '') {
      payload.currencyCode = String(terminalDetailsForm.currencyCode).trim();
    }
    if (terminalDetailsForm.countryCode !== null && terminalDetailsForm.countryCode !== undefined && String(terminalDetailsForm.countryCode) !== '') {
      payload.countryCode = String(terminalDetailsForm.countryCode).trim();
    }
    if (terminalDetailsForm.otp !== null && terminalDetailsForm.otp !== undefined && String(terminalDetailsForm.otp) !== '') {
      payload.otp = String(terminalDetailsForm.otp);
    }
    if (terminalDetailsForm.adminPass !== null && terminalDetailsForm.adminPass !== undefined && String(terminalDetailsForm.adminPass) !== '') {
      payload.adminPass = String(terminalDetailsForm.adminPass);
    }
    if (terminalDetailsForm.techPass !== null && terminalDetailsForm.techPass !== undefined && String(terminalDetailsForm.techPass) !== '') {
      payload.techPass = String(terminalDetailsForm.techPass);
    }

    setIsSavingTerminalDetails(true);

    fetchMssqlApi('nexgo/terminal', {method: 'PUT', hideNotification: true, data: payload},
      response => {
        setIsSavingTerminalDetails(false);
        notifyTerminalAction(
          response,
          terminalDetailsForm.tid,
          `Zapisano dane terminala ${terminalDetailsForm.tid}.`,
          `Terminal ${terminalDetailsForm.tid} nadal przetwarza zmiany.`
        );
        closeTerminalDetailsModal();
      },
      () => {
        setIsSavingTerminalDetails(false);
        handleTerminalActionError(terminalDetailsForm.tid, 'Nie udało się zapisać danych terminala.');
      }
    );
  };

  const [showDevicesListModal, setShowDevicesListModal] = useState(false);
  const [showMerchantsListModal, setShowMerchantsListModal] = useState(false);


  const [showImportQueueModal, setShowImportQueueModal] = useState(false);
  const [importQueue, setImportQueue] = useState({running: false, items: [], merchants: 0, terminals: 0, errors: 0});
  const [importQueueLoading, setImportQueueLoading] = useState(false);
  const [importQueueFilter, setImportQueueFilter] = useState('all');
  const [importQueuePage, setImportQueuePage] = useState(1);
  const [assignMerchantTerminalId, setAssignMerchantTerminalId] = useState(null);
  const [assignMerchantMid, setAssignMerchantMid] = useState('');
  const [assignMerchantSaving, setAssignMerchantSaving] = useState(false);

  const defaultFilter = {page: 1, merchantMid: null, merchantName: "", deviceSN: "", deviceModel: "", deviceAssignmentStatus: "NULL"};
  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({});

  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false)
  const [newDevicesText, setNewDevicesText] = useState('')

  const parseDeviceSns = () => [...new Set(String(newDevicesText || '').split(/\r?\n/).map(sn => sn.trim().toUpperCase().replace(/\s/g, '')).filter(Boolean))]

  const getDeviceData = sn => ({
    valid: /^N620[A-Z0-9]{7}$/.test(sn) || /^UN20[A-Z0-9]{7}$/.test(sn),
    model: sn.startsWith('N620') ? 'N62' : sn.startsWith('UN20') ? 'UN20' : ''
  })

  const saveNewDevices = () => {
    const sns = parseDeviceSns()
    if (!sns.length) return NotificationManager.error('Wklej przynajmniej jeden SN.', 'Błąd')
    const invalid = sns.filter(sn => !getDeviceData(sn).valid)
    if (invalid.length) return NotificationManager.error(`Niepoprawne SN: ${invalid.join(', ')}`, 'Błąd')
    fetchMssqlApi('nexgo/devices/bulk', {method: 'POST', hideNotification: true, data: {sns}},
      response => {
        const data = response?.data || {}
        if (data.added) NotificationManager.success(`Dodano ${data.added} urządzeń.`, 'Sukces')
        if (data.exists) NotificationManager.info(`${data.exists} urządzeń już istnieje.`, 'Info')
        if (data.errors) NotificationManager.warning(`${data.errors} urządzeń nie udało się dodać.`, 'Uwaga')
        setShowAddDeviceModal(false); setNewDevicesText(''); getDevices(); getAvailableDevices()
      },
      () => NotificationManager.error('Nie udało się dodać urządzeń.', 'Błąd')
    )
  }

  const [assignDeviceTerminal, setAssignDeviceTerminal] = useState(null);
  const [selectedDeviceSn, setSelectedDeviceSn] = useState('');
  const [deviceAssignmentMode, setDeviceAssignmentMode] = useState('auto');
  const [manualDeviceAction, setManualDeviceAction] = useState('bind');
  const [manualDeviceSn, setManualDeviceSn] = useState('');

  const closeDeviceAssignmentModal = () => {
    setAssignDeviceTerminal(null);
    setSelectedDeviceSn('');
    setDeviceAssignmentMode('auto');
    setManualDeviceAction('bind');
    setManualDeviceSn('');
  };

  const openDeviceAssignmentModal = terminal => {
    const currentSn = getTerminalSn(terminal);
    setAssignDeviceTerminal(terminal);
    setSelectedDeviceSn('');
    setDeviceAssignmentMode('auto');
    setManualDeviceAction(currentSn ? 'unbind' : 'bind');
    setManualDeviceSn(currentSn || '');
  };

  const changeDeviceAssignmentMode = manual => {
    const currentSn = getTerminalSn(assignDeviceTerminal);
    setDeviceAssignmentMode(manual ? 'manual' : 'auto');
    if (manual) {
      setManualDeviceAction(currentSn ? 'unbind' : 'bind');
      setManualDeviceSn(currentSn || '');
    }
  };

  const changeManualDeviceAction = action => {
    setManualDeviceAction(action);
    if (action === 'unbind' && !manualDeviceSn) setManualDeviceSn(getTerminalSn(assignDeviceTerminal));
  };

  const saveDeviceAssignment = () => {
    if (!assignDeviceTerminal?.tid) {NotificationManager.error('Brak TID terminala.', 'Błąd'); return;}
    if (!assignDeviceTerminal?.processorTid) {NotificationManager.error('Brak Processor TID terminala.', 'Błąd'); return;}

    const currentSn = getTerminalSn(assignDeviceTerminal);
    const isManual = deviceAssignmentMode === 'manual';
    const uiAction = isManual ? manualDeviceAction : (currentSn ? 'unbind' : 'bind');
    const dsn = String(isManual ? manualDeviceSn : (uiAction === 'unbind' ? currentSn : selectedDeviceSn)).trim().toUpperCase().replace(/\s/g, '');

    if (!dsn) {
      NotificationManager.error(uiAction === 'unbind' ? 'Wpisz urządzenie do odłączenia.' : 'Wybierz lub wpisz urządzenie do podłączenia.', 'Błąd');
      return;
    }

    const apiAction = uiAction === 'bind' && currentSn ? 'rebind' : uiAction;
    const tid = assignDeviceTerminal.tid;

    fetchMssqlApi(`nexgo/terminal/device`, {method: 'POST', data: {processorTid: assignDeviceTerminal.processorTid, dsn, action: apiAction}, hideNotification: true},
      response => {
        notifyTerminalAction(
          response,
          tid,
          uiAction === 'bind' ? `Połączono urządzenie ${dsn} z terminalem ${tid}.` : `Odłączono urządzenie ${dsn} od terminala ${tid}.`,
          `Terminal ${tid} nadal przetwarza ${uiAction === 'bind' ? 'połączenie' : 'odłączenie'} urządzenia.`
        );
        closeDeviceAssignmentModal();
        getAvailableDevices();
      },
      () => handleTerminalActionError(tid, uiAction === 'bind' ? 'Nie udało się połączyć urządzenia.' : 'Nie udało się odłączyć urządzenia.')
    );
  };
  const [dccAction, setDccAction] = useState(null);
  const openTerminalDCCModal = (terminal) => {
    if (!terminal?.tid) return;
    fetchMssqlApi('nexgo/terminal/parameters', { method: 'POST', hideNotification: true, data: {tid: terminal.tid}},
      (response) => {
        const parameters = response?.data?.items || [];
        const dccParameter = parameters.find((parameter) =>String(parameter?.name || '').toLowerCase() === 'dcc_supported');
        if (!dccParameter) {NotificationManager.error('Terminal nie posiada parametru dcc_supported.', 'Błąd'); return;}
        const isEnabled = String(dccParameter.value).toLowerCase() === 'true';
        setDccAction({terminal, parameter: dccParameter, isEnabled, newValue: isEnabled ? 'false' : 'true'});
      },
      () => {NotificationManager.error('Nie udało się pobrać parametrów terminala.', 'Błąd');}
    );
  };

  const saveTerminalDCC = () => {
    if (!dccAction?.terminal?.tid) return;
    const { terminal, parameter, newValue } = dccAction;
    const payload = [{...(parameter?.name ? { name: parameter.name } : { id: parameter.id }), value: newValue}];
    fetchMssqlApi(`nexgo/terminal/parameters/${terminal.tid}`, {method: 'PUT', hideNotification: true, data: payload},
      response => {
        notifyTerminalAction(response, terminal.tid, newValue === 'true' ? `Włączono DCC dla terminala ${terminal.tid}.` : `Wyłączono DCC dla terminala ${terminal.tid}.`);
        setDccAction(null);
      },
      () => handleTerminalActionError(terminal.tid, 'Nie udało się zmienić ustawienia DCC.')
    );
  };

  const [paymentAction, setPaymentAction] = useState(null);
  
  const isPaymentActive = (terminal, type) => {return !!(terminal?.auth?.[type]?.enabled);};
  const getPaymentName = (type) => {return type === 'blik' ? 'BLIK' : 'Kartą'};
  const getPaymentSuffix = (type) => {return type === 'blik' ? '25' : '07';};
  const getExistingPaymentTid = (terminal, type) => {return terminal?.auth?.[type]?.tid || '';};
  const getDefaultPaymentTid = (terminal, type) => {
    const existingTid = getExistingPaymentTid(terminal, type);
    if (existingTid) return existingTid;
    const processorTid = String(terminal?.processorTid || '').trim();
    if (/^[a-zA-Z0-9]{6}$/.test(processorTid)) {return `${processorTid}${getPaymentSuffix(type)}`}
    return '';
  };
  const openPaymentActionModal = (terminal, type) => {
    if (!terminal?.tid) return;
    const isActive = isPaymentActive(terminal, type);
    const action = isActive ? 'remove' : 'add';
    const paymentTid = isActive ? getExistingPaymentTid(terminal, type) : getDefaultPaymentTid(terminal, type);
    if (action === 'add' && !paymentTid) {NotificationManager.error('Nie można wygenerować TID płatności, bo terminal nie ma poprawnego processorTid.', 'Błąd'); return}
    setPaymentAction({terminal, type, action, paymentTid});
  };
  const savePaymentAction = () => {
    if (!paymentAction?.terminal?.tid) return;
    const {terminal, type, action, paymentTid} = paymentAction;
    const isAdd = action === 'add';
    fetchMssqlApi('nexgo/terminal', {method: 'PUT', data: {tid: terminal.tid, auth: {[type]: {enabled: isAdd, tid: paymentTid}}}, hideNotification: true},
      response => {notifyTerminalAction(response, terminal.tid, isAdd ? `Dodano płatność ${getPaymentName(type)}.` : `Usunięto płatność ${getPaymentName(type)}.`); setPaymentAction(null)},
      () => handleTerminalActionError(terminal.tid, 'Nie udało się zapisać ustawień płatności.')
    );
  };

  const [passwordTerminal, setPasswordTerminal] = useState(null);
  const [passwordForm, setPasswordForm] = useState({otp: '', adminPass: '', techPass: ''});

  const handlePasswordChange = (e) => {
    const {name, value} = e.target;
    setPasswordForm((prev) => ({...prev, [name]: value.replace(/\D/g, '')}));
  };
  const saveTerminalPasswords = () => {
    const tid = passwordTerminal?.tid;
    if (!tid) {NotificationManager.error('Brak TID terminala.', 'Błąd'); return}
    if (!/^[0-9]{6}$/.test(passwordForm.otp)) {NotificationManager.error('OTP musi mieć dokładnie 6 cyfr.', 'Błąd'); return}
    if (!/^[0-9]{4,6}$/.test(passwordForm.adminPass)) {NotificationManager.error('Hasło admina musi mieć od 4 do 6 cyfr.', 'Błąd'); return}
    if (!/^[0-9]{4,6}$/.test(passwordForm.techPass)) {NotificationManager.error('Hasło techniczne musi mieć od 4 do 6 cyfr.', 'Błąd'); return}
    fetchMssqlApi(`nexgo/terminal`, {method: 'PUT', data: {tid, otp: passwordForm.otp, adminPass: passwordForm.adminPass, techPass: passwordForm.techPass}, hideNotification: true},
      response => {notifyTerminalAction(response, tid, `Zapisano hasła dla terminala ${tid}.`); setPasswordTerminal(null); setPasswordForm({otp: '', adminPass: '', techPass: ''})},
      () => handleTerminalActionError(tid, 'Nie udało się zapisać haseł terminala.')
    );
  };

  const [terminalToUnenroll, setTerminalToUnenroll] = useState(null);

  const unenrollTerminal = () => {
    if (!terminalToUnenroll?.tid) return;
    const tid = terminalToUnenroll.tid;
    fetchMssqlApi(`nexgo/terminal/unenroll`, {method: 'POST', data: {tid}, hideNotification: true},
      response => notifyTerminalAction(response, tid, `Terminal ${tid} został wyrejestrowany.`, `Terminal ${tid} nadal przetwarza wyrejestrowanie.`),
      () => handleTerminalActionError(tid, `Nie udało się wyrejestrować terminala ${tid}.`)
    );
    setTerminalToUnenroll(null);
  };
  
  const [terminalTransactions, setTerminalTransactions] = useState([]);
  const [transactionsTerminalSN, setTransactionsTerminalSN] = useState('');

  const openTransactionsModal = (terminal) => {
    if (!terminal?.sn) return;
    setTransactionsTerminalSN(terminal?.sn);
    fetchMssqlApi(`nexgo/terminal/transactions`, {method: 'POST', hideNotification: true, data: {sn: terminal?.sn}},
      (response) => {setTerminalTransactions(response)},
      (err) => {setTerminalActivities([]); NotificationManager.error('Nie udało się pobrać transakcji terminala.', 'Błąd')}
    );
  };

  const [terminalActivities, setTerminalActivities] = useState([]);
  const [activityTerminalTid, setActivityTerminalTid] = useState('');

  const openActivityModal = (terminal) => {
    if (!terminal?.tid) return;
    setActivityTerminalTid(terminal?.tid);
    setTerminalActivities([]);
    fetchMssqlApi(`nexgo/terminal/activities`, { method: 'POST', hideNotification: true, data: {tid: terminal?.tid}},
      (response) => {setTerminalActivities(response?.data?.items);},
      (err) => {setTerminalActivities([]); NotificationManager.error('Nie udało się pobrać aktywności terminala.', 'Błąd');}
    );
  };

  const [terminalHistory, setTerminalHistory] = useState([]);
  const [terminalHistoryProcessorTid, setTerminalHistoryProcessorTid] = useState('');

  const openTerminalHistoryModal = (terminal) => {
    if (!terminal?.processorTid) return;
    setTerminalHistoryProcessorTid(terminal?.processorTid);
    setTerminalHistory([]);
    fetchMssqlApi(`nexgo/terminal/history`, { method: 'POST', hideNotification: true, data: {processorTid: terminal?.processorTid}},
      (response) => {setTerminalHistory(response?.data?.events || []);},
      (err) => {setTerminalHistory([]); NotificationManager.error('Nie udało się pobrać historii terminala.', 'Błąd');}
    );
  };

  const [deviceHistory, setDeviceHistory] = useState([]);
  const [deviceHistoryDSN, setDeviceHistoryDSN] = useState('');

  const openDeviceHistoryModal = (terminal) => {
    if (!terminal?.sn) return;
    setDeviceHistoryDSN(terminal?.sn);
    setDeviceHistory([]);
    fetchMssqlApi(`nexgo/device/history`, { method: 'POST', hideNotification: true, data: {dsn: terminal?.sn}},
      (response) => {setDeviceHistory(response?.data?.events || []);},
      (err) => {setDeviceHistory([]); NotificationManager.error('Nie udało się pobrać historii urządzenia.', 'Błąd');}
    );
  };

  const [deviceVerifyDSN, setDeviceVerifyDSN] = useState(null);
  const [terminalVerifyProcessorTid, setTerminalVerifyProcessorTid] = useState(null);
  const [isDeviceBindToGoodTerminal, setIsDeviceBindToGoodTerminal] = useState({});

  const openDeviceBindVerifyModal = (terminal) => {
    if (!terminal?.sn) return;
    if (!terminal?.processorTid) return;
    setDeviceVerifyDSN(terminal?.sn);
    setTerminalVerifyProcessorTid(terminal?.processorTid);
    fetchMssqlApi(`nexgo/device/bind/verify`, { method: 'POST', hideNotification: true, data: {dsn: terminal?.sn, processorTid: terminal?.processorTid}},
      (response) => {setIsDeviceBindToGoodTerminal(response?.data || {});},
      (err) => {setIsDeviceBindToGoodTerminal(null); NotificationManager.error('Nie udało się zweryfikowac przypisania urządzenia.', 'Błąd');}
    );
  };

  const publishTerminal = terminal => {
    const tid = String(terminal?.tid || '').trim()
    if (!tid) return NotificationManager.error('Brak TID terminala.', 'Błąd')
    fetchMssqlApi('nexgo/terminal/publish', {method: 'POST', data: {tid}, hideNotification: true},
      response => notifyTerminalAction(response, tid, `Opublikowano konfigurację terminala ${tid}.`, `Terminal ${tid} nadal pobiera / przetwarza konfigurację.`),
      () => handleTerminalActionError(tid, `Nie udało się opublikować konfiguracji terminala ${tid}.`)
    )
  }

  const [configurationTerminal, setConfigurationTerminal] = useState(null);
  const [selectedConfiguration, setSelectedConfiguration] = useState('');

  const openChangeConfigurationModal = (terminal) => {
    if (!terminal?.tid) return;
    setConfigurationTerminal(terminal);
    setSelectedConfiguration(terminal?.configuration?.requested?.name || '');
  };

  const saveTerminalConfiguration = () => {
    const tid = configurationTerminal?.tid;
    const configuration = String(selectedConfiguration || '').trim();

    if (!tid) return NotificationManager.error('Brak TID terminala.', 'Błąd');
    if (!configuration) return NotificationManager.error('Wybierz konfigurację.', 'Błąd');

    fetchMssqlApi(`nexgo/terminal/configuration/${tid}`, {method: 'PUT', hideNotification: true, data: {name: configuration}},
      response => {
        notifyTerminalAction(response, tid, `Zmieniono konfigurację terminala ${tid} na ${configuration}.`, `Terminal ${tid} nadal pobiera / przetwarza konfigurację.`);
        setConfigurationTerminal(null);
        setSelectedConfiguration('');
      },
      () => handleTerminalActionError(tid, 'Nie udało się zmienić konfiguracji terminala.')
    );
  };

  const [terminalParameters, setTerminalParameters] = useState([]);
  const [paramsTerminal, setParamsTerminal] = useState(null);

  const openTerminalParametersModal = (terminal) => {
    const terminalTid = typeof terminal === 'string' ? terminal : terminal?.tid;
    if (!terminalTid) return;
    if (typeof terminal !== 'string') setParamsTerminal(terminal);
    setTerminalParameters([]);
    fetchMssqlApi(`nexgo/terminal/parameters`, {method: 'POST', hideNotification: true, data: {tid: terminalTid}},
      (response) => {setTerminalParameters(response?.data?.items.map((p, index) => ({id: `${p?.name || p?.id || 'param'}-${index}`, apiId: p?.id || '', name: p?.name || '', value: p?.value ?? '', originalValue: p?.value ?? '', level: p?.level || ''})))},
      (err) => {NotificationManager.error('Nie udało się pobrać parametrów terminala.', 'Błąd')}
    );
  };
  const saveTerminalParameters = (terminalTid) => {
    if (!terminalTid) return;
    const payload = terminalParameters.filter((p) => (p?.name || p?.apiId) && String(p?.value ?? '') !== String(p?.originalValue ?? '')).map((p) => ({...(p?.name ? { name: p.name } : { id: p.apiId }), value: p.value ?? ''}));
    if (payload.length === 0) {NotificationManager.info('Nie zmieniono żadnych parametrów.', 'Info'); return}
    fetchMssqlApi(`nexgo/terminal/parameters/${terminalTid}`, {method: 'PUT', data: payload, hideNotification: true},
      response => {notifyTerminalAction(response, terminalTid, `Zapisano parametry dla terminala ${terminalTid}.`); openTerminalParametersModal(terminalTid)},
      () => handleTerminalActionError(terminalTid, 'Nie udało się zapisać parametrów terminala.')
    );
  };

  const [showAddTerminalModal, setShowAddTerminalModal] = useState(false);
  const [newTerminalForm, setNewTerminalForm] = useState({
    tid: '',
    mid: '',
    configuration: '',
    processorTid: '',
    processorMid: '',
    mcc: '5499',
    address: {
      street: '',
      zipCode: '',
      city: '',
      district: '',
      country: 'PL',
    },
  });
  const [merchantSearch, setMerchantSearch] = useState('')

  const selectMerchant = value => {
    setMerchantSearch(value)
    const merchant = merchants.find(m => `${m?.mid} - ${m?.name}` === value)
    if (!merchant) {
      setNewTerminalForm(prev => ({ ...prev, mid: '' }))
      return
    }
    setNewTerminalForm(prev => ({
      ...prev,
      mid: merchant?.mid || '',
      processorMid: merchant?.processorMid || '',
      mcc: merchant?.mcc || '5499',
      address: {
        street: merchant?.address?.street || '',
        zipCode: merchant?.address?.zipCode || '',
        city: merchant?.address?.city || '',
        district: merchant?.address?.district || '',
        country: merchant?.address?.country || merchant?.address?.coutry || 'PL'
      }
    }))
  }

  const openAddTerminalModal = () => {
    setMerchantSearch('')
    setNewTerminalForm({
      mid: '',
      configuration: '',
      processorTid: '',
      processorMid: '',
      mcc: '',
      address: {
        street: '',
        zipCode: '',
        city: '',
        district: '',
        country: 'PL'
      }
    })
    setShowAddTerminalModal(true)
  }
  const handleNewTerminalChange = (e) => {
    const { name, value} = e.target;
    if (name.startsWith('address.')) {
      const field = name.replace('address.', '');
      setNewTerminalForm((prev) => ({...prev, address: {...prev.address, [field]: value}}));
      return;
    };
    setNewTerminalForm((prev) => ({...prev, [name]: name === 'tid' || name === 'processorTid' ? value.toUpperCase().replace(/\s/g, '') : name === 'mcc' ? value.replace(/\D/g, ''): value}));
  };
  const saveNewTerminal = () => {
    const processorTid = String(newTerminalForm.processorTid || '').trim()
    const terminalData = {
      mid: String(newTerminalForm.mid || '').trim(),
      configuration: String(newTerminalForm.configuration || '').trim(),
      processorTid,
      processorMid: String(newTerminalForm.processorMid || '').trim() || undefined,
      mcc: String(newTerminalForm.mcc || '').trim(),
      otp: '123456',
      adminPass: '1122',
      techPass: '1122',
      address: {
        street: String(newTerminalForm.address.street || '').trim(),
        zipCode: String(newTerminalForm.address.zipCode || '').trim(),
        city: String(newTerminalForm.address.city || '').trim(),
        district: String(newTerminalForm.address.district || '').trim() || undefined,
        country: String(newTerminalForm.address.country || '').trim() || 'PL'
      },
      auth: {
        cards: {enabled: true, tid: `${processorTid}07`},
        blik: {enabled: true, tid: `${processorTid}25`}
      }
    }
    if (!terminalData.mid) return NotificationManager.error('Wybierz klienta / MID.', 'Błąd')
    if (!terminalData.configuration) return NotificationManager.error('Wybierz konfigurację.', 'Błąd')
    if (!/^[a-zA-Z0-9]{6,8}$/.test(processorTid)) return NotificationManager.error('Processor TID musi mieć od 6 do 8 znaków alfanumerycznych.', 'Błąd')
    if (!terminalData.mcc) return NotificationManager.error('Wpisz MCC.', 'Błąd')
    if (!terminalData.address.street || !terminalData.address.zipCode || !terminalData.address.city) return NotificationManager.error('Wpisz ulicę, kod pocztowy i miasto.', 'Błąd')
    fetchMssqlApi('nexgo/terminals/next-tid', {method: 'GET', hideNotification: true},
      response => {
        const tid = String(response?.data?.tid || response?.data?.next_tid || response?.data?.nextTid || '').trim()
        if (!/^[a-zA-Z0-9]{8}$/.test(tid)) return NotificationManager.error('Nie udało się pobrać poprawnego TID terminala.', 'Błąd')
        fetchMssqlApi('nexgo/terminal', {method: 'POST', data: {...terminalData, tid}, hideNotification: true},
          response => {
            if (response?.processing) NotificationManager.info(`Terminal ${tid} został utworzony i nadal pobiera / przetwarza konfigurację.`, 'W toku')
            else NotificationManager.success(`Dodano terminal ${tid}.`, 'Sukces')
            setShowAddTerminalModal(false)
            getTerminal(tid, true)
          },
          () => handleTerminalActionError(tid, 'Nie udało się dodać terminala.')
        )
      },
      () => NotificationManager.error('Nie udało się pobrać następnego TID.', 'Błąd')
    )
  }

  const [showConfigureTerminalsModal, setShowConfigureTerminalsModal] = useState(false)
  const [configureMerchantSearch, setConfigureMerchantSearch] = useState('')
  const [configureMerchant, setConfigureMerchant] = useState(null)
  const [freeTerminals, setFreeTerminals] = useState([])
  const [isFreeTerminalsLoading, setIsFreeTerminalsLoading] = useState(false)
  const [isConfigureSaving, setIsConfigureSaving] = useState(false)
  const freeTerminalsRequestId = useRef(0)

  // Dodatkowe zabezpieczenie UI przed starym cache; backend jest finalnym autorytetem.
  const occupiedConfigure = useMemo(() => {
    const tids = new Set()
    const sns = new Set()
    terminals.forEach(t => {
      if (!t?.tid || (!t?.sn && !t?.bindSN)) return
      tids.add(String(t.tid))
      ;[t.sn, t.bindSN].forEach(sn => {
        if (sn) sns.add(String(sn).trim().toUpperCase())
      })
    })
    return {tids, sns}
  }, [terminals])
  const selectableFreeTerminals = useMemo(() => freeTerminals.filter(t => !occupiedConfigure.tids.has(String(t?.tid))), [freeTerminals, occupiedConfigure])
  const selectableAvailableDevices = useMemo(() => availableDevices.filter(d => !occupiedConfigure.sns.has(String(d?.sn || '').trim().toUpperCase())), [availableDevices, occupiedConfigure])
  const emptyConfigureRow = () => ({tid: '', processorTid: '', sn: '', configuration: ''})
  const [configureRows, setConfigureRows] = useState([emptyConfigureRow()])

  const getConfigurationBySn = sn => {
    const value = String(sn || '').toUpperCase()
    const wanted = value.startsWith('N620') ? 'n62-unattended' : value.startsWith('UN20') ? 'UN20-unattended' : ''
    return configurations.find(c => normalize(c?.name) === normalize(wanted))?.name || wanted
  }

  const getFreeTerminals = mid => {
    const requestId = ++freeTerminalsRequestId.current
    if (!mid) {setFreeTerminals([]); setIsFreeTerminalsLoading(false); return}
    setIsFreeTerminalsLoading(true)
    fetchMssqlApi('nexgo/terminals/available', {method: 'POST', hideNotification: true, data: {mid}},
      response => {
        if (requestId !== freeTerminalsRequestId.current) return
        setFreeTerminals(response?.data?.items || [])
        setIsFreeTerminalsLoading(false)
      },
      () => {
        if (requestId !== freeTerminalsRequestId.current) return
        setFreeTerminals([])
        setIsFreeTerminalsLoading(false)
        NotificationManager.error('Nie udało się pobrać wolnych TViD.', 'Błąd')
      }
    )
  }

  const openConfigureTerminalsModal = () => {
    setConfigureMerchantSearch('')
    setConfigureMerchant(null)
    setConfigureRows([emptyConfigureRow()])
    setFreeTerminals([])
    getAvailableDevices()
    setShowConfigureTerminalsModal(true)
  }

  const closeConfigureTerminalsModal = () => {
    ++freeTerminalsRequestId.current
    setIsFreeTerminalsLoading(false)
    setShowConfigureTerminalsModal(false)
    setConfigureMerchantSearch('')
    setConfigureMerchant(null)
    setConfigureRows([emptyConfigureRow()])
    setFreeTerminals([])
  }

  const selectConfigureMerchant = value => {
    setConfigureMerchantSearch(value)
    const merchant = merchants.find(m => `${m?.mid} - ${m?.name}` === value)
    setConfigureMerchant(merchant || null)
    setConfigureRows([emptyConfigureRow()])
    if (merchant?.mid) getFreeTerminals(merchant.mid)
    else setFreeTerminals([])
  }

  const updateConfigureRow = (index, field, value) => {
  setConfigureRows(prev => prev.map((row, i) => {
    if (i !== index) return row

    if (field === 'processorTid') {
      const processorTid = String(value || '').toUpperCase().replace(/\s/g, '')
      const terminal = selectableFreeTerminals.find(t => String(t?.processorTid || '').toUpperCase() === processorTid)
      return {...row, processorTid, tid: terminal?.tid || ''}
    }

    if (field === 'sn') {
      const sn = String(value || '').toUpperCase().replace(/\s/g, '')
      return {...row, sn, configuration: getConfigurationBySn(sn)}
    }

    return {...row, [field]: value}
  }))
}

  const addConfigureRow = () => setConfigureRows(prev => [...prev, emptyConfigureRow()])

  const removeConfigureRow = index => setConfigureRows(prev => prev.length > 1 ? prev.filter((_, i) => i !== index) : [emptyConfigureRow()])

  const assignFreeTvid = processorTid => setConfigureRows(prev => {
    if (prev.some(row => String(row?.processorTid) === String(processorTid))) return prev

    const terminal = selectableFreeTerminals.find(t => String(t?.processorTid) === String(processorTid))
    const emptyIndex = prev.findIndex(row => !row?.processorTid)

    if (emptyIndex === -1) return [...prev, {...emptyConfigureRow(), tid: terminal?.tid || '', processorTid}]

    return prev.map((row, i) => i === emptyIndex ? {...row, tid: terminal?.tid || '', processorTid} : row)
  })

  const isTvidUsed = (processorTid, index) => configureRows.some((row, i) => i !== index && String(row?.processorTid) === String(processorTid))

  const isSnUsed = (sn, index) => configureRows.some((row, i) => i !== index && String(row?.sn) === String(sn))

  const saveConfigureTerminals = () => {
    if (isConfigureSaving || isFreeTerminalsLoading) return
    const items = configureRows.filter(row => row?.processorTid || row?.sn)

    if (!configureMerchant?.mid) return NotificationManager.error('Wybierz klienta.', 'Błąd')
    if (!items.length) return NotificationManager.error('Dodaj przynajmniej jeden terminal.', 'Błąd')
    if (items.some(row => !row?.tid || !row?.processorTid || !row?.sn || !row?.configuration)) return NotificationManager.error('Uzupełnij TViD, SN i konfigurację we wszystkich pozycjach.', 'Błąd')
    if (new Set(items.map(row => row.processorTid)).size !== items.length) return NotificationManager.error('Ten sam TViD został wybrany więcej niż raz.', 'Błąd')
    if (new Set(items.map(row => row.sn)).size !== items.length) return NotificationManager.error('Ten sam SN został wybrany więcej niż raz.', 'Błąd')
    if (items.some(row => !selectableFreeTerminals.some(t => String(t?.tid) === String(row?.tid) && String(t?.processorTid).toUpperCase() === String(row?.processorTid).toUpperCase()))) return NotificationManager.error('Wybrany TViD jest już zajęty lub nie ma go na aktualnej liście wolnych TViD. Odśwież listę.', 'Błąd')
    if (items.some(row => occupiedConfigure.sns.has(String(row?.sn || '').trim().toUpperCase()))) return NotificationManager.error('Wybrany SN jest już powiązany z innym terminalem.', 'Błąd')

    setIsConfigureSaving(true)
    fetchMssqlApi('nexgo/terminals/configure-bulk', {method: 'POST', hideNotification: true, data: {mid: configureMerchant.mid, items}},
      response => {
        setIsConfigureSaving(false)
        const data = response?.data || {}
        const accepted = (data.items || []).filter(row => row.status === 'SUCCESS' || row.status === 'PROCESSING')
        if (accepted.length) {
          const acceptedTids = new Set(accepted.map(row => String(row.tid)))
          const acceptedSns = new Set(accepted.map(row => String(row.sn || '').toUpperCase()))
          setFreeTerminals(prev => prev.filter(row => !acceptedTids.has(String(row?.tid))))
          setAvailableDevices(prev => prev.filter(row => !acceptedSns.has(String(row?.sn || '').toUpperCase())))
          setTerminals(prev => prev.map(terminal => {
            const assigned = accepted.find(row => String(row.tid) === String(terminal?.tid))
            return assigned ? {...terminal, bindSN: assigned.sn, deviceAssignmentStatus: 'BOUND'} : terminal
          }))
        }
        if (data.success) NotificationManager.success(`Skonfigurowano i aktywowano ${data.success} terminali.`, 'Sukces')
        if (data.processing) NotificationManager.info(`${data.processing} terminali nadal pobiera / przetwarza konfigurację.`, 'W toku')
        if (data.errors) {
          const errors = (data.items || []).filter(x => x.status === 'ERROR').map(x => `${x.processorTid || '-'} / ${x.sn || '-'}: ${x.error || 'Błąd'}`)
          NotificationManager.warning(`${data.errors} pozycji zakończyło się błędem.${errors.length ? ` ${errors.join(' | ')}` : ''}`, 'Uwaga')
        }

        // Nie nadpisujemy natychmiast lokalnego BIND SN potencjalnie starym cache.
        // Kolejne pobranie listy pokaże stan utrwalony przez backend.
        closeConfigureTerminalsModal()
        getDevices()
        getAvailableDevices()
        getMerchants()
      },
      () => {setIsConfigureSaving(false); NotificationManager.error('Nie udało się skonfigurować terminali.', 'Błąd')}
    )
  }

  const [showAddMerchantModal, setShowAddMerchantModal] = useState(false);
  const [newMerchantForm, setNewMerchantForm] = useState({
    name: '',
    taxId: '',
    processorMid: '',
    mcc: '',
    address: {
      street: '',
      zipCode: '',
      city: '',
      district: '',
      country: 'PL',
    },
  });

  const openAddMerchantModal = () => {
    setNewMerchantForm({
      name: '',
      taxId: '',
      processorMid: '',
      mcc: '5499',
      address: {
        street: '',
        zipCode: '',
        city: '',
        district: '',
        country: 'PL',
      },
    });
    setShowAddMerchantModal(true);
  };

  const handleNewMerchantChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('address.')) {
      const field = name.replace('address.', '');
      setNewMerchantForm((prev) => ({...prev, address: {...prev.address, [field]: value}}));
      return;
    }
    setNewMerchantForm((prev) => ({...prev, [name]: name === 'mcc' || name === 'taxId' ? value.replace(/\D/g, '') : value}));
  };

  const saveNewMerchant = () => {
    const payload = {
      name: String(newMerchantForm.name || '').trim(),
      taxId: String(newMerchantForm.taxId || '').trim(),
      processorMid: String(newMerchantForm.processorMid || '').trim() || undefined,
      mcc: String(newMerchantForm.mcc || '').trim(),
      address: {
        street: String(newMerchantForm.address.street || '').trim(),
        zipCode: String(newMerchantForm.address.zipCode || '').trim(),
        city: String(newMerchantForm.address.city || '').trim(),
        district: String(newMerchantForm.address.district || '').trim() || undefined,
        country: String(newMerchantForm.address.country || '').trim() || 'PL'
      }
    };

    if (!payload.name) return NotificationManager.error('Wpisz nazwę klienta.', 'Błąd');
    if (!payload.taxId) return NotificationManager.error('Wpisz NIP / taxId.', 'Błąd');
    if (!payload.mcc) return NotificationManager.error('Wpisz MCC.', 'Błąd');
    if (!payload.address.street || !payload.address.zipCode || !payload.address.city) return NotificationManager.error('Wpisz ulicę, kod pocztowy i miasto.', 'Błąd');

    fetchMssqlApi('nexgo/merchants/next-mid', {method: 'GET', hideNotification: true},
      response => {
        const mid = String(response?.data?.mid || response?.data?.next_mid || response?.data?.nextMid || '').trim();
        if (!mid) return NotificationManager.error('Nie udało się pobrać następnego MID.', 'Błąd');

        fetchMssqlApi('nexgo/merchant', {method: 'POST', data: {...payload, mid}, hideNotification: true},
          () => {NotificationManager.success(`Dodano klienta ${payload.name}.`, 'Sukces'); getMerchants(); setShowAddMerchantModal(false)},
          () => NotificationManager.error('Nie udało się dodać klienta.', 'Błąd')
        );
      },
      () => NotificationManager.error('Nie udało się pobrać następnego MID.', 'Błąd')
    );
  };
  

  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [merchantProcessorMid, setMerchantProcessorMid] = useState('');

  const merchantNotesText = Array.isArray(selectedMerchant?.notes)
    ? selectedMerchant.notes.map((n) => n?.note).filter(Boolean).join('\n')
    : selectedMerchant?.note || '-';

  const openMerchantDetailsModal = (midValue) => {
    if (!midValue) return;

    fetchMssqlApi('nexgo/merchants', {method: 'POST', hideNotification: true, data: {mid: midValue}},
      (response) => {
        const merchant = response?.data;
        setSelectedMerchant(merchant);
        setMerchantProcessorMid(merchant?.processorMid || '');
      },
      () => NotificationManager.error('Nie udało się pobrać danych klienta.', 'Błąd')
    );
  };

  const saveMerchantProcessorMid = () => {
    const mid = selectedMerchant?.mid;
    const processorMid = String(merchantProcessorMid || '').trim();

    if (!mid) return NotificationManager.error('Brak MID klienta.', 'Błąd');

    fetchMssqlApi('nexgo/merchant', {
      method: 'PUT',
      hideNotification: true,
      data: {
        mid,
        processorMid
      }
    },
      () => {
        NotificationManager.success(`Zmieniono Processor MID klienta ${mid}.`, 'Sukces');
        setSelectedMerchant(prev => ({...prev, processorMid}));
        getMerchants();
      },
      () => NotificationManager.error('Nie udało się zmienić Processor MID.', 'Błąd')
    );
  };

  const getImportQueue = () => {
    setImportQueueLoading(true);
    fetchMssqlApi('nexgo/import/queue', {method: 'GET', hideNotification: true},
      response => {
        setImportQueue(response?.data || {running: false, items: [], merchants: 0, terminals: 0, errors: 0});
        setImportQueueLoading(false);
      },
      () => {
        setImportQueueLoading(false);
        NotificationManager.error('Nie udało się odczytać kolejki z cache.', 'Błąd');
      }
    );
  };

  const formatQueueAddress = address => {
    if (typeof address === 'string') return address.trim() || '-';
    if (!address || typeof address !== 'object') return '-';
    const street = [address?.street || address?.line1 || '', address?.houseNo || address?.buildingNumber || ''].filter(Boolean).join(' ');
    return [street, address?.line2, [address?.zipCode || address?.postalCode || '', address?.city || ''].filter(Boolean).join(' '), address?.district, address?.country || address?.coutry].filter(Boolean).join(', ') || '-';
  };

  const merchantAddressScore = (terminalAddress, merchantAddress) => {
    const normalizePart = value => String(value || '').toLocaleLowerCase('pl-PL').trim().replace(/\s+/g, ' ');
    if (!terminalAddress || typeof terminalAddress !== 'object' || !merchantAddress || typeof merchantAddress !== 'object') return 0;
    let score = 0;
    if (normalizePart(terminalAddress?.zipCode || terminalAddress?.postalCode) && normalizePart(terminalAddress?.zipCode || terminalAddress?.postalCode) === normalizePart(merchantAddress?.zipCode || merchantAddress?.postalCode)) score += 4;
    if (normalizePart(terminalAddress?.city) && normalizePart(terminalAddress?.city) === normalizePart(merchantAddress?.city)) score += 2;
    if (normalizePart(terminalAddress?.street) && normalizePart(terminalAddress?.street) === normalizePart(merchantAddress?.street)) score += 2;
    return score;
  };

  const assignMerchantToQueueTerminal = terminal => {
    const processorTid = String(terminal?.id || '').trim();
    if (!processorTid || !assignMerchantMid || assignMerchantSaving) return;
    setAssignMerchantSaving(true);
    fetchMssqlApi('nexgo/import/queue/assign-merchant', {method: 'POST', hideNotification: true, data: {processorTid, mid: assignMerchantMid}},
      response => {
        setAssignMerchantSaving(false);
        setAssignMerchantTerminalId(null);
        setAssignMerchantMid('');
        NotificationManager.success(`Przypisano Processor MID ${response?.data?.processorMid || terminal.processorMid}. Automat ponowi import w następnym cyklu.`, 'Sukces');
        setMerchants(prev => prev.map(merchant => String(merchant?.mid) === String(response?.data?.mid) ? {...merchant, processorMid: response?.data?.processorMid} : merchant));
        getImportQueue();
      },
      err => {
        setAssignMerchantSaving(false);
        NotificationManager.error(err?.response?.data?.data?.message || err?.response?.data?.message || 'Nie udało się przypisać Processor MID.', 'Błąd');
      }
    );
  };

  const openImportQueueModal = () => {
    setImportQueueFilter('all');
    setImportQueuePage(1);
    setAssignMerchantTerminalId(null);
    setAssignMerchantMid('');
    setShowImportQueueModal(true);
    getImportQueue();
  };

  const filteredImportQueue = (importQueue.items || []).filter(item =>
    importQueueFilter === 'all' ||
    (importQueueFilter === 'errors' && !!item.error) ||
    item.type === importQueueFilter
  );
  const importQueuePageSize = 100;
  const importQueuePages = Math.max(1, Math.ceil(filteredImportQueue.length / importQueuePageSize));
  const visibleImportQueue = filteredImportQueue.slice((importQueuePage - 1) * importQueuePageSize, importQueuePage * importQueuePageSize);

  const getTerminals = (f, rowsPerPage, pageNo) => {
    fetchMssqlApi("nexgo/terminals", {method: 'POST', hideNotification: true, data: {
        mid: f.merchantMid,
        limit: rowsPerPage || f.rowsPerPage,
        page: pageNo,
        sn: f.deviceSN,
        model: f.deviceModel,
        deviceAssignmentStatus: f.deviceAssignmentStatus
      }},
      (response) => {
        if (Array.isArray(response?.data?.items)) setTerminals(response.data.items);
        if (response?.stale) NotificationManager.warning('Pokazano ostatnią poprawną wersję listy terminali z cache.', 'Nexgo niedostępne');
      },
      () => NotificationManager.warning('Nie udało się odświeżyć terminali. Zachowano aktualną listę.', 'Nexgo niedostępne')
  )};
  const getMerchants = () => {
    fetchMssqlApi('nexgo/merchants/terminals',{ method: 'POST', hideNotification: true },
      (response) => {setMerchants(response?.data?.items || []);},
      (err) => {setMerchants([]); NotificationManager.error('Nie udało się pobrać klientów.', 'Błąd')}
  )};
  const getAvailableDevices = () => {
    fetchMssqlApi('nexgo/devices/available', {method: 'POST', hideNotification: true },
      (response) => {setAvailableDevices(response?.data?.items || [])},
      (err) => {setAvailableDevices([]); NotificationManager.error('Nie udało się pobrać dostępnych urządzeń.', 'Błąd')}
  )};
  const getDevices = () => {
    fetchMssqlApi('nexgo/devices',{method: 'POST', hideNotification: true },
      (response) => {setDevices(response?.data?.items || []); setDevicesModels((response?.data?.items || []).filter((item, index, arr) => item?.model && arr.findIndex(x => x?.model === item?.model) === index))},
      (err) => {setDevices([]); setDevicesModels([]); NotificationManager.error('Nie udało się pobrać urządzeń.', 'Błąd')}
  )};
  const getConfigurations = () => {
    fetchMssqlApi('nexgo/configurations', {method: 'GET', hideNotification: true}, 
      (response) => {setConfigurations(response?.data?.items || [])},
      (err) => {setConfigurations([]); NotificationManager.error('Nie udało się pobrać konfiguracji.', 'Błąd')}
  )};

  const [filters, setFilters] = useState({client: '', clientR24: '', device: '', address: '', configuration: '', tids: '', passwords: '',  status: ''});

  const handleFilterChange = (e) => {const { name, value } = e.target; setFilters((prev) => ({...prev, [name]: value}))};
  const displayedTerminals = terminals.filter((t) => {
    const clientText = [t?.mid, t?.merchantName].map(normalize).join(' ');
    const clientR24Text = [t?.r24?.CustomerName, t?.r24?.CustomerAbbr].map(normalize).join(' ');
    const deviceText = [t?.sn, t?.tid, t?.processorTid].map(normalize).join(' ');
    const addressText = [t?.address?.street, t?.address?.zipCode, t?.address?.city, t?.address?.district, t?.address?.country, t?.address?.coutry, t?.mcc].map(normalize).join(' ');
    const configurationText = [
      t?.configuration?.requested?.name, formatTs(t?.configuration?.requested?.createdAt),
      t?.configuration?.published?.name, formatTs(t?.configuration?.published?.createdAt),
      t?.configuration?.installed?.name, formatTs(t?.configuration?.installed?.createdAt),
    ].map(normalize).join(' ');
    const paymentsText = [t?.auth?.cards?.enabled ? 'tak' : 'nie', t?.auth?.cards?.tid, t?.auth?.blik?.enabled ? 'tak' : 'nie', t?.auth?.blik?.tid,].map(normalize).join(' ');
    const passwordsText = [t?.passwords?.otp, t?.passwords?.admin, t?.passwords?.tech].map(normalize).join(' ');
    const statusText = [t?.status?.status, t?.status?.enrollment?.status, formatTs(t?.status?.enrollment?.time), t?.status?.downloading?.status, formatTs(t?.status?.downloading?.time)].map(normalize).join(' ');
    return (
      clientText.includes(normalize(filters.client)) &&
      clientR24Text.includes(normalize(filters.clientR24)) &&
      deviceText.includes(normalize(filters.device)) &&
      addressText.includes(normalize(filters.address)) &&
      configurationText.includes(normalize(filters.configuration)) &&
      paymentsText.includes(normalize(filters.payments)) &&
      passwordsText.includes(normalize(filters.passwords)) &&
      statusText.includes(normalize(filters.status))
    );
  });

  useEffect(() => {
    setHeaderData('Nexgo Terminale');
    getMerchants();
    getDevices();
    getAvailableDevices();
    getConfigurations();
  }, [setHeaderData]);

  return (
    <>
      <SearchFilter 
        filterName="nexgo"
        defaultFilter={defaultFilter}
        onFilterChange={(f) => setFilter(f)}
        onSettingsChange={(s) => setSettingsFilter(s)}
        search={getTerminals}
        totalCount={terminals.length}
        forNow
      />
      <div className="custom-scroll overflow-auto border" style={{ height: 'calc(100vh - 120px)', overflow: 'auto', width: '100%' }}>
        <table className="table table-striped mb-0" style={{ tableLayout: "fixed" }}>
          <colgroup>
            <col style={{ minWidth: "200px"}}/>
            <col style={{ minWidth: "200px"}}/>
            <col style={{ width: "150px" }} />
            <col style={{ width: "140px" }} />
            <col style={{ width: "240px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "160px" }} />
            <col style={{ width: "80px" }} />
          </colgroup>
          <thead className="headers-stick-trxs">
            <tr className="text-center">
              <th className="p-1">
                <div className="d-flex flex-column align-items-center">
                  Klient PayTel
                  <input type="text" name="client" value={filters.client} onChange={handleFilterChange} placeholder="Szukaj..." className="form-control form-control-sm text-center" style={{ maxWidth: '120px', maxHeight: '20px' }}/>
                </div>
              </th>
              <th className="p-1">
                <div className="d-flex flex-column align-items-center">
                  Klient R24
                  <input type="text" name="clientR24" value={filters.clientR24} onChange={handleFilterChange} placeholder="Szukaj..." className="form-control form-control-sm text-center" style={{ maxWidth: '120px', maxHeight: '20px' }}/>
                </div>
              </th>

              <th className="p-1">
                <div className="d-flex flex-column align-items-center">
                  Urządzenie
                  <input type="text" name="device" value={filters.device} onChange={handleFilterChange} placeholder="Szukaj..." className="form-control form-control-sm text-center" style={{ maxWidth: '120px', maxHeight: '20px' }}/>
                </div>
              </th>

              <th className="p-1">
                <div className="d-flex flex-column align-items-center">
                  Płatności
                  <div>
                    <span className='badge badge-success mr-1'>Karta</span>
                    <span className='badge badge-danger'>BLIK</span>
                  </div>
                  <input type="text" name="payments" value={filters.payments} onChange={handleFilterChange} placeholder="Szukaj..." className="form-control form-control-sm text-center" style={{ maxWidth: '120px', maxHeight: '20px' }}/>
                </div>
              </th>

              <th className="p-1">
                <div className="d-flex flex-column align-items-center">
                  Aktualizacja
                  <div>
                    <span className='badge badge-success mr-1'>Zgodna</span>
                    <span className='badge badge-danger mr-1'>Niezgodna</span>
                  </div>
                  <input type="text" name="configuration" value={filters.configuration} onChange={handleFilterChange} placeholder="Szukaj..." className="form-control form-control-sm text-center" style={{ maxWidth: '120px', maxHeight: '20px' }}/>
                </div>
              </th>

              <th className="p-1">
                <div className="d-flex flex-column align-items-center">
                  Hasła<br/>
                  <div>
                    <span className="badge badge-primary mr-1">OTP</span>
                    <span className="badge badge-success mr-1">Admin</span>
                    <span className="badge badge-danger">Tech</span>
                  </div>
                  <input type="text" name="passwords" value={filters.passwords} onChange={handleFilterChange} placeholder="Szukaj..." className="form-control form-control-sm text-center" style={{ maxWidth: '120px', maxHeight: '20px' }}/>
                </div>
              </th>

              <th className="p-1">
                <div className="d-flex flex-column align-items-center">
                  Status <br/>
                  <div>
                    <span className="badge badge-light">Ogólny</span>
                    <span className="badge badge-light">Enrollment</span>
                    <span className="badge badge-light">Pobieranie</span>
                  </div>
                  <input type="text" name="status" value={filters.status} onChange={handleFilterChange} placeholder="Szukaj..." className="form-control form-control-sm text-center" style={{ maxWidth: '120px', maxHeight: '20px' }}/>
                </div>
              </th>
              <th className="p-1 text-center align-middle" style={{ minWidth: '150px' }}>
                <div className="d-flex justify-content-end mb-1">
                  <Dropdown autoFocus={false} popperConfig={{strategy: 'fixed'}} style={{zIndex: 99999}}>
                    <Dropdown.Toggle size="sm" variant="dark" id="nexgo-actions-dropdown" style={{ minWidth: "50px", height: "26px" }}>
                      <i className="fas fa-bars mr-1" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu alignRight popperConfig={{strategy: 'fixed'}} style={{minWidth: '230px', zIndex: 9999}} className="p-1 m-1">
                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={refreshAllCache} disabled={isRefreshingAllCache}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px'}}>
                            <i className={`fas fa-sync-alt text-primary${isRefreshingAllCache ? ' fa-spin' : ''}`}/>
                          </span>
                          <span>{isRefreshingAllCache ? 'Odświeżanie...' : 'Odśwież wszystkie dane'}</span>
                        </span>
                      </Dropdown.Item>

                      <Dropdown.Divider/>
                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={openConfigureTerminalsModal}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px', flexShrink: 0}}><i className="fas fa-bolt text-success"/></span>
                          <span>Skonfiguruj terminale</span>
                        </span>
                      </Dropdown.Item>

                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={() => setShowAddDeviceModal(true)}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px', flexShrink: 0}}><i className="fas fa-plus text-success"/></span>
                          <span>Dodaj urządzenia</span>
                        </span>
                      </Dropdown.Item>

                      <Dropdown.Divider />

                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={openAddTerminalModal}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px', flexShrink: 0}}><i className="fas fa-plus text-dark"/></span>
                          <span>Dodaj terminal ręcznie</span>
                        </span>
                      </Dropdown.Item>

                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={openAddMerchantModal}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px', flexShrink: 0}}><i className="fas fa-plus text-dark"/></span>
                          <span>Dodaj klienta</span>
                        </span>
                      </Dropdown.Item>

                      <Dropdown.Divider />

                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={() => setShowMerchantsListModal(true)}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px', flexShrink: 0}}><i className="fas fa-users text-primary"/></span>
                          <span>Klienci</span>
                        </span>
                      </Dropdown.Item>

                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={() => setShowDevicesListModal(true)}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px', flexShrink: 0}}><i className="fas fa-mobile-alt text-primary"/></span>
                          <span>Urządzenia</span>
                        </span>
                      </Dropdown.Item>

                      <Dropdown.Item as="button" className="mb-1 px-2 py-1" onClick={openImportQueueModal}>
                        <span className="d-flex align-items-center text-nowrap">
                          <span className="text-center mr-2" style={{width: '24px', flexShrink: 0}}><i className="fas fa-download text-primary"/></span>
                          <span>Kolejka importu</span>
                        </span>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {displayedTerminals.map((t, i) => {
              return (
                <tr key={t?.tid || i}>
                  <td className="p-1 text-center align-middle">
                    {t?.mid ? (
                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => openMerchantDetailsModal(t?.mid)} disabled={!t?.mid}>
                        {t?.merchantName}
                      </button>
                    ) : (
                      <p>Brak klienta</p>
                    )}
                  </td>
                  <td className="p-1 text-center align-middle">
                    {t?.r24?.CustomerName} <strong>{t?.r24?.CustomerAbbr && `(${t?.r24?.CustomerAbbr})`}</strong>
                  </td>

                  <td className="p-1">
                    {!t?.bindSN ? (
                      <>
                        <span className={`${!t?.sn && "badge badge-danger"}`} style={{ fontSize: "90%"}}><strong>SN: </strong>{t?.sn || 'Brak'}</span>
                        <span className="badge badge-secondary p-1 m-0 ml-1" style={{ fontSize: "90%"}}>Brak historii powiązania</span>
                      </>
                    ) : t?.sn && String(t.sn).toUpperCase() === String(t.bindSN).toUpperCase() ? (
                      <span className="badge badge-success p-1 m-0" style={{ fontSize: "90%"}} title={`Powiązanie poprawne${t?.bindVerifiedAt ? `: ${formatTs(t.bindVerifiedAt)}` : ''}`}><strong>SN: </strong>{t.sn}</span>
                    ) : !t?.sn ? (
                      <span className="badge badge-warning p-1 m-0" style={{ fontSize: "90%"}} title="Urządzenie zostało powiązane, ale terminal nie zakończył jeszcze enrollmentu">BIND SN: {t.bindSN}</span>
                    ) : (
                      <>
                        <span style={{ fontSize: "90%"}}><strong>SN: </strong>{t.sn}</span>
                        <span className="badge badge-danger p-1 m-0 ml-1" style={{ fontSize: "90%"}} title={`BIND SN: ${t.bindSN}${t?.bindVerifiedAt ? ` | ${formatTs(t.bindVerifiedAt)}` : ''}`}><i className="fas fa-unlink p-0 m-0 mr-1"/>Niepoprawne powiązanie: {t?.bindReason || `${t.sn} ≠ ${t.bindSN}`}</span>
                      </>
                    )}

                    <br/>
                    <span className={`${!t?.processorTid && "badge badge-danger"}`} style={{ fontSize: "90%"}}><strong>TvID: </strong>{t?.processorTid || 'Brak'}</span><br/>
                    <span className={`${!t?.tid && "badge badge-danger"}`} style={{ fontSize: "90%"}}><strong>TID: </strong>{t?.tid || 'Brak'}</span>
                  </td>

                  <td className="p-1 text-center align-middle">
                    <div className="d-flex flex-column align-items-center">
                      <div className="d-flex align-items-center align-middle"><i className={t?.auth?.cards?.enabled ? 'py-0 m-0 text-primary fas fa-check-square' : 'py-0 m-0 text-primary far fa-square'} /><span className="badge badge-success" style={{ fontSize: "90%"}}>{t?.auth?.cards?.tid || '-'}</span></div>
                      <div className="d-flex align-items-center align-middle"><i className={t?.auth?.blik?.enabled ? 'py-0 m-0 text-primary fas fa-check-square' : 'py-0 m-0 text-primary far fa-square'} /><span className="badge badge-danger" style={{ fontSize: "90%"}}>{t?.auth?.blik?.tid || '-'}</span></div>
                    </div>
                  </td>

                  <td className="p-1 text-center align-middle">
                    <div>
                      {!t?.configuration?.installed?.name ? (
                        <span className="badge badge-secondary" style={{fontSize: "90%"}}>Brak zainstalowanej konfiguracji<br/>{t?.configuration?.requested?.name && <><strong>P: </strong>{t.configuration.requested.name}<br/></>}{t?.configuration?.published?.name && <><strong>O: </strong>{t.configuration.published.name}</>}</span>
                      ) : t?.configuration?.requested?.name === t?.configuration?.published?.name && t?.configuration?.published?.name === t?.configuration?.installed?.name ? (
                        <span className="badge badge-success" style={{fontSize: "90%"}}>{t?.configuration?.installed?.name}<br/><small>{formatTs(t?.configuration?.installed?.createdAt)}</small></span>
                      ) : isTerminalProcessing(t) ? (
                        <span className="badge badge-warning" style={{fontSize: "90%"}} title={`Przygotowana: ${formatTs(t?.configuration?.requested?.createdAt)} \n Opublikowana: ${formatTs(t?.configuration?.published?.createdAt)} \n Zainstalowana: ${formatTs(t?.configuration?.installed?.createdAt)}`}>Pobieranie / przetwarzanie...<br/>P: {t?.configuration?.requested?.name || '-'}<br/>O: {t?.configuration?.published?.name || '-'}<br/>I: {t?.configuration?.installed?.name || '-'}</span>
                      ) : (
                        <span className="badge badge-danger" style={{fontSize: "90%"}} title={`Przygotowana: ${formatTs(t?.configuration?.requested?.createdAt)} \n Opublikowana: ${formatTs(t?.configuration?.published?.createdAt)} \n Zainstalowana: ${formatTs(t?.configuration?.installed?.createdAt)}`}>Niezgodna konfiguracja<br/>P: {t?.configuration?.requested?.name || '-'}<br/>O: {t?.configuration?.published?.name || '-'}<br/>I: {t?.configuration?.installed?.name || '-'}</span>
                      )}
                    </div>
                  </td>

                  <td className="p-1 text-center align-middle">
                    <span className="badge badge-primary" style={{ fontSize: "90%"}}>{t?.passwords?.otp || '-'}</span><br/>
                    <span className="badge badge-success" style={{ fontSize: "90%"}}>{t?.passwords?.admin || '-'}</span><br/>
                    <span className="badge badge-danger" style={{ fontSize: "90%"}}>{t?.passwords?.tech || '-'}</span>
                  </td>

                  <td className="p-1 text-center align-middle">
                    <div className="d-flex justify-content-between align-items-center mb-1"></div>
                    <span className={isTerminalProcessing(t) ? 'badge badge-warning' : getStatusBadgeClass(t?.status?.status || '-')} style={{ fontSize: "90%"}}>{isTerminalProcessing(t) ? 'W TOKU' : (t?.status?.status || '-')}</span><br/>
                    <span className={getStatusBadgeClass(t?.status?.enrollment?.status || '-')} title={`Enrollment: ${formatTs(t?.status?.enrollment?.time)}`} style={{ fontSize: "90%"}}>{t?.status?.enrollment?.status || '-'}</span><br/>
                    <span className={getStatusBadgeClass(t?.status?.downloading?.status || '-')} title={`Downloading: ${formatTs(t?.status?.downloading?.time)}`} style={{ fontSize: "90%"}}>{t?.status?.downloading?.status || '-'}</span>
                  </td>
                  <td className="p-1 text-center align-middle">
                    <Dropdown alignRight>
                      <Dropdown.Toggle size="sm" variant="outline-dark">
                        Akcje
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => openTerminalDetailsModal(t)} disabled={!t?.tid}>
                          Wyświetl dane terminala
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => refreshTerminalCache(t)} disabled={!t?.tid}>
                          Odśwież dane terminala
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openActivityModal(t)} disabled={!(t?.tid)}>
                          Aktywność
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openTerminalParametersModal(t)} disabled={!(t?.tid)}>
                          Parametry
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openTerminalHistoryModal(t)} disabled={!(t?.processorTid)}>
                          Historia terminala
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openDeviceHistoryModal(t)} disabled={!(t?.sn)}>
                          Historia urządzenia
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openTransactionsModal(t)} disabled={!(t?.sn)}>
                          Transakcje
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => {setPasswordTerminal(t); setPasswordForm({otp: t?.passwords?.otp || '', adminPass: t?.passwords?.admin || '', techPass: t?.passwords?.tech || ''})}} disabled={!(t?.tid)}>
                          Zmień hasła
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openDeviceBindVerifyModal(t)} disabled={!(t?.processorTid && t?.sn)}>
                          Sprawdź poprawność powiązania
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openTerminalDCCModal(t)} disabled={!(t?.tid)}>
                          Włącz/wyłącz DCC
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => openPaymentActionModal(t, 'cards')} disabled={!isPaymentActive(t, 'cards') && !getDefaultPaymentTid(t, 'cards')} className={isPaymentActive(t, 'cards') ? 'text-danger' : ''}>
                          {isPaymentActive(t, 'cards') ? 'Usuń płatność Kartą' : 'Dodaj płatność Kartą'}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openPaymentActionModal(t, 'blik')} disabled={!isPaymentActive(t, 'blik') && !getDefaultPaymentTid(t, 'blik')} className={isPaymentActive(t, 'blik') ? 'text-danger' : ''}>
                          {isPaymentActive(t, 'blik') ? 'Usuń płatność BLIK' : 'Dodaj płatność BLIK'}
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => openDeviceAssignmentModal(t)} disabled={!t?.processorTid}>
                          Połącz / odłącz urządzenie
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => openChangeConfigurationModal(t)} disabled={!t?.tid}>
                          Zmień konfigurację
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => publishTerminal(t)} disabled={!t?.tid}>
                          Opublikuj konfigurację
                        </Dropdown.Item>
                        <Dropdown.Item className="text-danger" onClick={() => {setTerminalToUnenroll(t);}} disabled={(t?.status?.enrollment?.status === "NOT_ENROLLED")}>
                          Wyrejestruj terminal
                        </Dropdown.Item>
                    
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              );
            })}
            {displayedTerminals.length === 0 && (
              <tr>
                <td colSpan="8" className="text-center p-3">Brak terminali.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {selectedMerchant && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">{selectedMerchant?.name || ''}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => setSelectedMerchant(null)} />
                </div>
                <div className="modal-body">
                  <div className="row g-2">
                    <div className="col-md-12">
                      <label className="form-label fw-bold">Nazwa</label>
                      <div className="form-control bg-light">{selectedMerchant?.name || '-'}</div>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold">MID</label>
                      <div className="form-control bg-light">{selectedMerchant?.mid || '-'}</div>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold">Processor MID</label>
                      <input
                        type="text"
                        className="form-control"
                        value={merchantProcessorMid}
                        onChange={(e) => setMerchantProcessorMid(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-bold">MCC</label>
                      <div className="form-control bg-light">{selectedMerchant?.mcc || '-'}</div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-bold">Utworzono</label>
                      <div className="form-control bg-light">{formatTs(selectedMerchant?.createdAt)}</div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-bold">Zaktualizowano</label>
                      <div className="form-control bg-light">{formatTs(selectedMerchant?.updatedAt)}</div>
                    </div>
                    <div className="col-12"><hr /></div>
                    <div className="col-12"><h6>Adres</h6></div>
                    <div className="col-md-6">
                      <label className="form-label fw-bold">Ulica</label>
                      <div className="form-control bg-light">{selectedMerchant?.address?.street || '-'}</div>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label fw-bold">Kod pocztowy</label>
                      <div className="form-control bg-light">{selectedMerchant?.address?.zipCode || '-'}</div>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label fw-bold">Miasto</label>
                      <div className="form-control bg-light">{selectedMerchant?.address?.city || '-'}</div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-bold">Województwo / District</label>
                      <div className="form-control bg-light">{selectedMerchant?.address?.district || '-'}</div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-bold">Kraj</label>
                      <div className="form-control bg-light">
                        {selectedMerchant?.address?.country || selectedMerchant?.address?.coutry || '-'}
                      </div>
                    </div>
                    <div className="col-12"><hr /></div>
                    <div className="col-12"><h6>Kontakty</h6></div>
                    {selectedMerchant.contacts?.length > 0 ? (
                      selectedMerchant.contacts.map((contact, index) => (
                        <div className="col-12" key={`${contact?.email || 'contact'}-${index}`}>
                          <div className="border rounded p-3 bg-light">
                            <div><strong>Imię i nazwisko:</strong> {contact?.name || '-'}</div>
                            <div><strong>Email:</strong> {contact?.email || '-'}</div>
                            <div><strong>Telefon:</strong> {contact?.phone || '-'}</div>
                            <div><strong>Utworzono:</strong> {formatTs(contact?.createdAt)}</div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12">
                        <div className="form-control bg-light">Brak kontaktów.</div>
                      </div>
                    )}
                    <div className="col-12"><hr /></div>
                    <div className="col-12">
                      <label className="form-label fw-bold">Notatki</label>
                      <textarea className="form-control bg-light" rows="5" value={merchantNotesText} readOnly/>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setSelectedMerchant(null)}
                  >
                    Zamknij
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={saveMerchantProcessorMid}
                    disabled={String(merchantProcessorMid || '').trim() === String(selectedMerchant?.processorMid || '').trim()}
                  >
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {showMerchantsListModal && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Lista klientów</h5>
                  <div className="d-flex align-items-center">
                    <Button size="sm" variant="success" className="mr-2" onClick={openAddMerchantModal}><i className="fas fa-plus mr-1" />Dodaj klienta</Button>
                    <Button size="sm" variant="outline-primary" className="mr-2" onClick={() => setShowMerchantsListModal(false)}>Zamknij</Button>
                  </div>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr className="text-center">
                          <th style={{ minWidth: '140px' }}>MID</th>
                          <th style={{ minWidth: '300px' }}>Nazwa</th>
                          <th style={{ minWidth: '150px' }}>Terminale</th>
                          <th style={{ minWidth: '140px' }}>MCC</th>
                          <th style={{ minWidth: '300px' }}>Adres</th>
                        </tr>
                      </thead>
                      <tbody>
                        {merchants.map((m, index) => (
                          <tr key={m?.mid || index}>
                            <td className="text-center align-middle">{m?.mid || '-'}</td>
                            <td className="text-center align-middle">{m?.name || '-'}</td>
                            <td className="text-center align-middle"><span title={m?.AssignedDevices?.join('\n')}>Przypisane tidy: {m?.AssignedDeviceCount || '-'}</span><br/><span title={m?.NotAssignedDevices?.join('\n')}>Nie przypisane tidy: {m?.NotAssignedDeviceCount || '-'}</span></td>
                            <td className="text-center align-middle">{m?.mcc || '-'}</td>
                            <td className="text-center align-middle">
                              {m?.address?.street || '-'}<br />
                              {m?.address?.zipCode || '-'} {m?.address?.city || '-'}<br />
                              {m?.address?.district || '-'} {m?.address?.country || m?.address?.coutry || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {showAddMerchantModal && (
        <>
          <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Dodaj klienta</h5>
                  <button type="button" className="btn btn-link px-2 fas fa-times" onClick={() => setShowAddMerchantModal(false)}/>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">NIP</label>
                      <input name="taxId" className="form-control" value={newMerchantForm.taxId} onChange={handleNewMerchantChange} placeholder="np. 1234567890"/>
                    </div>
                    <div className="col-md-12 form-group">
                      <label className="font-weight-bold">Nazwa</label>
                      <input name="name" className="form-control" value={newMerchantForm.name} onChange={handleNewMerchantChange} placeholder="Nazwa klienta"/>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Processor MID</label>
                      <input name="processorMid" className="form-control" value={newMerchantForm.processorMid} onChange={handleNewMerchantChange} placeholder="Opcjonalnie"/>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">MCC</label>
                      <input name="mcc" className="form-control" value={newMerchantForm.mcc} onChange={handleNewMerchantChange} placeholder="np. 5499"/>
                    </div>
                    <div className="col-12">
                      <hr/><h6>Adres</h6>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Ulica</label>
                      <input name="address.street" className="form-control" value={newMerchantForm.address.street} onChange={handleNewMerchantChange}/>
                    </div>
                    <div className="col-md-3 form-group">
                      <label className="font-weight-bold">Kod pocztowy</label>
                      <input name="address.zipCode" className="form-control" value={newMerchantForm.address.zipCode} onChange={handleNewMerchantChange}placeholder="00-001"/>
                    </div>
                    <div className="col-md-3 form-group">
                      <label className="font-weight-bold">Miasto</label>
                      <input name="address.city" className="form-control" value={newMerchantForm.address.city} onChange={handleNewMerchantChange}/>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Województwo</label>
                      <input name="address.district" className="form-control" value={newMerchantForm.address.district} onChange={handleNewMerchantChange}/>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Kraj</label>
                      <input name="address.country" className="form-control" value={newMerchantForm.address.country} onChange={handleNewMerchantChange}/>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button variant="secondary" onClick={() => setShowAddMerchantModal(false)}>
                    Anuluj
                  </Button>
                  <Button variant="success"onClick={() => saveNewMerchant()}>
                      Dodaj klienta
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {showAddTerminalModal && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Dodaj terminal</h5>
                  <button type="button" className="btn btn-link px-2 fas fa-times" onClick={() => setShowAddTerminalModal(false)}/>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Processor TID</label>
                      <input name="processorTid" className="form-control" value={newTerminalForm.processorTid} onChange={handleNewTerminalChange} placeholder="np. 283784" maxLength="8"/>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Klient / MID</label>
                      <input type="text" list="merchantList" className="form-control" value={merchantSearch} onChange={e => selectMerchant(e.target.value)} placeholder="Wpisz MID lub nazwę..."/>
                      <datalist id="merchantList">
                        {merchants.map(m => <option key={m?.mid} value={`${m?.mid} - ${m?.name}`} />)}
                      </datalist>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Konfiguracja</label>
                      <select name="configuration" className="custom-select" value={newTerminalForm.configuration} onChange={handleNewTerminalChange}>
                        <option value="">{'Wybierz konfigurację'}</option>
                        {configurations.map((configuration) => (
                          <option key={configuration?.id} value={configuration?.name || ""}>
                            {configuration?.name + " " + configuration?.id}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <hr />
                      <h6>Adres terminala</h6>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Ulica</label>
                      <input name="address.street" className="form-control" value={newTerminalForm.address.street} onChange={handleNewTerminalChange}/>
                    </div>
                    <div className="col-md-3 form-group">
                      <label className="font-weight-bold">Kod pocztowy</label>
                      <input name="address.zipCode" className="form-control" value={newTerminalForm.address.zipCode} onChange={handleNewTerminalChange} placeholder="00-001"/>
                    </div>
                    <div className="col-md-3 form-group">
                      <label className="font-weight-bold">Miasto</label>
                      <input name="address.city" className="form-control" value={newTerminalForm.address.city} onChange={handleNewTerminalChange}/>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Województwo</label>
                      <input name="address.district" className="form-control" value={newTerminalForm.address.district} onChange={handleNewTerminalChange}/>
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="font-weight-bold">Kraj</label>
                      <input name="address.country" className="form-control" value={newTerminalForm.address.country} onChange={handleNewTerminalChange}/>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button variant="secondary" onClick={() => setShowAddTerminalModal(false)}>
                    Anuluj
                  </Button>
                  <Button variant="success" onClick={saveNewTerminal}>
                    Dodaj terminal
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {showConfigureTerminalsModal && <>
        <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-light border-bottom">
                <div>
                  <h5 className="modal-title mb-1">Konfiguracja terminali</h5>
                  <small className="text-muted">Wybierz klienta, TViD, urządzenie i konfigurację</small>
                </div>
                <button type="button" className="btn btn-link text-dark px-2" onClick={closeConfigureTerminalsModal}><i className="fas fa-times"/></button>
              </div>

              <div className="modal-body bg-light p-3">
                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-body py-3">
                    <div className="row align-items-end">
                      <div className="col-md-7">
                        <label className="font-weight-bold mb-1"><i className="fas fa-building text-primary mr-2"/>Klient</label>
                        <input type="text" list="configureMerchantList" className="form-control" value={configureMerchantSearch} onChange={e => selectConfigureMerchant(e.target.value)} placeholder="Wpisz MID lub nazwę klienta..."/>
                        <datalist id="configureMerchantList">
                          {merchants.map(m => <option key={m?.mid} value={`${m?.mid} - ${m?.name}`}/>)}
                        </datalist>
                      </div>

                      <div className="col-md-5 mt-3 mt-md-0">
                        {configureMerchant ? (
                          <div className="border rounded bg-white px-3 py-2">
                            <div className="d-flex justify-content-between">
                              <strong>{configureMerchant?.name || '-'}</strong>
                              <span className="badge badge-primary">NIP: {configureMerchant?.taxId || '-'}</span>
                            </div>
                            <small className="text-muted"><i className="fas fa-map-marker-alt mr-1"/>{configureMerchant?.address?.city || '-'}, {configureMerchant?.address?.street || '-'}</small>
                          </div>
                        ) : (
                          <div className="border rounded bg-white text-muted text-center px-3 py-3"><i className="fas fa-arrow-left mr-2"/>Wybierz klienta</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {configureMerchant && (
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-body py-2 d-flex align-items-center">
                          <div className="rounded bg-light p-2 mr-3"><i className="fas fa-credit-card text-primary fa-lg"/></div>
                          <div>
                            <small className="text-muted d-block">Wolne TViD</small>
                            <strong className="h5 mb-0">{selectableFreeTerminals.filter(t => !configureRows.some(row => String(row.processorTid) === String(t.processorTid))).length}</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-body py-2 d-flex align-items-center">
                          <div className="rounded bg-light p-2 mr-3"><i className="fas fa-mobile-alt text-success fa-lg"/></div>
                          <div>
                            <small className="text-muted d-block">Wolne urządzenia</small>
                            <strong className="h5 mb-0">{selectableAvailableDevices.length}</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-body py-2 d-flex align-items-center">
                          <div className="rounded bg-light p-2 mr-3"><i className="fas fa-check-circle text-success fa-lg"/></div>
                          <div>
                            <small className="text-muted d-block">Gotowe</small>
                            <strong className="h5 mb-0">{configureRows.filter(row => row.processorTid && row.sn && row.configuration).length}<small className="text-muted"> / {configureRows.length}</small></strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {!configureMerchant ? (
                  <div className="card border-0 shadow-sm">
                    <div className="card-body text-center py-5 text-muted">
                      <i className="fas fa-store fa-3x mb-3 text-secondary"/>
                      <h6>Najpierw wybierz klienta</h6>
                      <small>Po wybraniu klienta pojawią się wolne TViD-y i urządzenia.</small>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-lg-9">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                          <div>
                            <strong>Terminale do konfiguracji</strong>
                            <small className="text-muted d-block">Konfiguracja zostanie automatycznie dobrana na podstawie SN</small>
                          </div>
                          <Button size="sm" variant="outline-primary" onClick={addConfigureRow}><i className="fas fa-plus mr-1"/>Dodaj pozycję</Button>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover mb-0">
                            <thead className="thead-light">
                              <tr>
                                <th className="text-center" style={{width: '50px'}}>#</th>
                                <th>TViD / TID</th>
                                <th>Urządzenie</th>
                                <th>Konfiguracja</th>
                                <th className="text-center" style={{width: '90px'}}>Status</th>
                                <th style={{width: '55px'}}/>
                              </tr>
                            </thead>

                            <tbody>
                              {configureRows.map((row, index) => {
                                const ready = row?.processorTid && row?.sn && row?.configuration

                                return (
                                  <tr key={index}>
                                    <td className="text-center align-middle"><span className="badge badge-light border">{index + 1}</span></td>

                                    <td className="align-middle">
                                      <input type="text" list={`configureTvids-${index}`} className={`form-control form-control-sm ${row?.processorTid ? 'border-success' : ''}`} value={row.processorTid} onChange={e => updateConfigureRow(index, 'processorTid', e.target.value)} placeholder="Wpisz lub wybierz TViD..."/>
                                      <datalist id={`configureTvids-${index}`}>
                                        {selectableFreeTerminals.filter(t => !isTvidUsed(t?.processorTid, index)).map(t => <option key={t?.processorTid} value={t?.processorTid}>TID: {t?.tid || '-'}</option>)}
                                      </datalist>
                                      {row?.tid && <small className="text-muted d-block mt-1">TID: <strong>{row.tid}</strong></small>}
                                    </td>

                                    <td className="align-middle">
                                      <input type="text" list={`configureDevices-${index}`} className={`form-control form-control-sm ${row?.sn ? 'border-success' : ''}`} value={row.sn} onChange={e => updateConfigureRow(index, 'sn', e.target.value)} placeholder="Wpisz lub wybierz SN..."/>
                                      <datalist id={`configureDevices-${index}`}>
                                        {selectableAvailableDevices.filter(device => !isSnUsed(device?.sn, index)).map(device => <option key={device?.sn} value={device?.sn}>{device?.model || ''}</option>)}
                                      </datalist>
                                    </td>

                                    <td className="align-middle">
                                      <input type="text" list={`configureConfigurations-${index}`} className={`form-control form-control-sm ${row?.configuration ? 'border-success' : ''}`} value={row.configuration} onChange={e => updateConfigureRow(index, 'configuration', e.target.value)} placeholder="Wpisz lub wybierz konfigurację..."/>
                                      <datalist id={`configureConfigurations-${index}`}>
                                        {configurations.map((configuration, i) => <option key={configuration?.name || i} value={configuration?.name}/>)}
                                      </datalist>
                                    </td>

                                    <td className="text-center align-middle">
                                      {ready ? <span className="badge badge-success"><i className="fas fa-check m-0 p-1 mr-1"/>Gotowe</span> : <span className="badge badge-warning">Uzupełnij</span>}
                                    </td>

                                    <td className="text-center align-middle">
                                      <Button size="sm" variant="outline-danger" disabled={configureRows.length === 1} onClick={() => removeConfigureRow(index)} title="Usuń pozycję"><i className="fas fa-trash"/></Button>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 mt-3 mt-lg-0">
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                          <div>
                            <strong>Wolne TViD-y</strong>
                            <small className="text-muted d-block">Kliknij, aby dodać</small>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="badge badge-primary badge-pill mr-2">{selectableFreeTerminals.filter(t => !configureRows.some(row => String(row.processorTid) === String(t.processorTid))).length}</span>
                            <Button size="sm" variant="outline-secondary" disabled={isFreeTerminalsLoading || !configureMerchant?.mid} onClick={() => {getFreeTerminals(configureMerchant.mid); getAvailableDevices()}} title="Odśwież wolne TViD-y i urządzenia z cache">
                              <i className={`fas ${isFreeTerminalsLoading ? 'fa-spinner fa-spin' : 'fa-sync-alt'}`}/>
                            </Button>
                          </div>
                        </div>

                        <div className="card-body p-2" style={{maxHeight: '430px', overflowY: 'auto'}}>
                          {isFreeTerminalsLoading && <div className="text-muted text-center py-3"><i className="fas fa-spinner fa-spin mr-2"/>Pobieranie wolnych TViD-ów...</div>}
                          {!isFreeTerminalsLoading && selectableFreeTerminals.length === 0 && (
                            <div className="text-center text-muted py-4">
                              <i className="fas fa-inbox fa-2x mb-2"/>
                              <small className="d-block">Brak wolnych TViD-ów</small>
                            </div>
                          )}

                          {selectableFreeTerminals.map(terminal => {
                            const used = configureRows.some(row => String(row.processorTid) === String(terminal.processorTid))

                            return (
                              <button key={terminal.processorTid} type="button" className={`btn btn-sm btn-block text-left mb-2 p-2 ${used ? 'btn-light text-muted border' : 'btn-outline-primary'}`} disabled={used} onClick={() => assignFreeTvid(terminal.processorTid)}>
                                <div className="d-flex justify-content-between align-items-center">
                                  <div><i className={`fas ${used ? 'fa-check-circle' : 'fa-plus-circle'} mr-2`}/><strong>{terminal.processorTid}</strong></div>
                                  {used && <span className="badge badge-success">wybrany</span>}
                                </div>
                                <small className="d-block mt-1 ml-4">TID: {terminal.tid || '-'}</small>
                              </button>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-footer bg-white">
                <div className="mr-auto">
                  {configureMerchant && <small className="text-muted"><i className="fas fa-info-circle mr-1"/>Do zapisania: <strong>{configureRows.filter(row => row.processorTid && row.sn && row.configuration).length}</strong></small>}
                </div>
                <Button variant="outline-secondary" onClick={closeConfigureTerminalsModal}>Anuluj</Button>
                <Button variant="success" onClick={saveConfigureTerminals} disabled={isConfigureSaving || isFreeTerminalsLoading || !configureMerchant || !configureRows.some(row => row.processorTid && row.sn && row.configuration)}><i className={`fas ${isConfigureSaving ? 'fa-spinner fa-spin' : 'fa-bolt'} mr-2`}/>{isConfigureSaving ? 'Konfigurowanie...' : 'Skonfiguruj i aktywuj'}</Button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"/>
      </>}
      {paramsTerminal && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Parametry terminala {paramsTerminal?.tid || ''}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => {setParamsTerminal(null); setTerminalParameters([]);}}/>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Nazwa</th>
                          <th>Wartość</th>
                          <th>Level</th>
                        </tr>
                      </thead>
                      <tbody>
                        {terminalParameters.map((param, index) => (
                          <tr key={param.id}>
                            <td>{param.name || '-'}</td>
                            <td><input className="form-control form-control-sm" value={param.value || ''} onChange={(e) => {const value = e.target.value; setTerminalParameters((prev) => prev.map((item, i) => (i === index ? { ...item, value } : item)))}}/></td>
                            <td><span className="badge badge-light">{param.level || '-'}</span></td>
                          </tr>
                        ))}
                        {terminalParameters.length === 0 && (<tr><td colSpan="3" className="text-center">Brak parametrów.</td></tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => {setParamsTerminal(null); setTerminalParameters([])}}>
                    Zamknij
                  </button>
                  <button type="button" className="btn btn-outline-primary" disabled={!paramsTerminal?.tid} onClick={() => saveTerminalParameters(paramsTerminal?.tid)}>
                    Zapisz parametry
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {activityTerminalTid && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1"role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Aktywność terminala {activityTerminalTid}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => {setTerminalActivities([]); setActivityTerminalTid('');}}/>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr className="text-center">
                          <th>Data, Czas</th>
                          <th>Akcja</th>
                        </tr>
                      </thead>
                      <tbody>
                        {terminalActivities.map((t, i) => (
                          <tr key={i}>
                            <td className="text-center">{formatTs(t?.createdAt)}</td>
                            <td className="text-center">{t?.action}</td>
                          </tr>
                        ))}
                        {terminalActivities.length === 0 && (
                          <tr><td colSpan="4" className="text-center p-3">Brak aktywności dla terminala.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {transactionsTerminalSN && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1"role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Transakcje terminala {transactionsTerminalSN}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => {setTerminalTransactions([]); setTransactionsTerminalSN('')}}/>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr className="text-center">
                          <th>Data, Czas</th>
                          <th>Klient (xyz)</th>
                          <th>Numer seryjny automatu</th>
                          <th>Kwota</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {terminalTransactions.map((t, i) => (
                          <tr key={i}>
                            <td className="text-center">{t?.CreateDateTime}</td>
                            <td className="text-center">{t?.Customer}</td>
                            <td className="text-center">{t?.MachineSerialNo}</td>
                            <td className="text-center">{t?.Price}</td>
                            <td className="text-center">{t?.Status}</td>
                          </tr>
                        ))}
                        {terminalTransactions.length === 0 && (
                          <tr><td colSpan="5" className="text-center p-3">Brak transakcji dla terminala.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {terminalToUnenroll && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Potwierdzenie wyrejestrowania</h5>
                  <button type="button" className="btn btn-link px-2 fas fa-times" onClick={() => setTerminalToUnenroll(null)}/>
                </div>
                <div className="modal-body">
                  <p>Czy na pewno chcesz wyrejestrować ten terminal?</p>
                  <div className="border rounded p-3 bg-light">
                    <strong>Klient:</strong>{' '} {terminalToUnenroll?.merchantName || '-'}<br/>
                    <strong>MID:</strong>{' '} {terminalToUnenroll?.mid || '-'}<br/>
                    <strong>Terminal:</strong>{' '} {terminalToUnenroll?.tid || '-'}<br/>
                    <strong>TID:</strong>{' '} {terminalToUnenroll?.auth?.cards?.tid || terminalToUnenroll?.tid || '-'}<br/>
                    <strong>Urządzenie SN:</strong>{' '} {terminalToUnenroll?.sn || '-'}
                  </div>
                </div>
                <div className="modal-footer">
                  <Button variant="secondary" onClick={() => setTerminalToUnenroll(null)}>
                    Anuluj
                  </Button>
                  <Button variant="danger" onClick={() => unenrollTerminal()}>
                    Tak
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {passwordTerminal && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog" >
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Zmiana haseł terminala {passwordTerminal?.tid || ''}</h5>
                  <button type="button" className="btn btn-link px-2 fas fa-times" onClick={() => {setPasswordTerminal(null); setPasswordForm({otp: '', adminPass: '', techPass: ''})}}/>
                </div>
                <div className="modal-body">
                  <div className="border rounded p-3 bg-light mb-3">
                    <strong>Terminal TID:</strong> {passwordTerminal?.tid || '-'}<br/>
                    <strong>Urządzenie SN:</strong> {passwordTerminal?.sn || '-'}<br/>
                    <strong>Klient:</strong> {passwordTerminal?.merchantName || '-'}
                  </div>
                  <div className="form-group">
                    <label className="font-weight-bold">OTP</label>
                    <input type="text" name="otp" className="form-control" value={passwordForm.otp} onChange={handlePasswordChange} maxLength="6" placeholder="np. 123456"/>
                  </div>
                  <div className="form-group">
                    <label className="font-weight-bold">Hasło admina</label>
                    <input type="text" name="adminPass" className="form-control" value={passwordForm.adminPass} onChange={handlePasswordChange} maxLength="6" placeholder="np. 1122"/>
                  </div>
                  <div className="form-group">
                    <label className="font-weight-bold">Hasło techniczne</label>
                    <input type="text" name="techPass" className="form-control" value={passwordForm.techPass} onChange={handlePasswordChange} maxLength="6" placeholder="np. 1122"/>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button variant="secondary" onClick={() => {setPasswordTerminal(null); setPasswordForm({otp: '', adminPass: '', techPass: ''})}}>
                    Anuluj
                  </Button>
                  <Button variant="primary" onClick={saveTerminalPasswords}>
                    Zapisz hasła
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {dccAction && (
        <>
          <div
            className="modal fade show"
            style={{
              display: 'block',
              backgroundColor: 'rgba(0,0,0,0.45)',
            }}
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
            >
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {dccAction.isEnabled ? 'Wyłącz DCC' : 'Włącz DCC'}
                  </h5>

                  <button
                    type="button"
                    className="btn btn-link fas fa-times"
                    onClick={() => setDccAction(null)}
                  />
                </div>

                <div className="modal-body">
                  Czy na pewno chcesz{' '}
                  <strong>
                    {dccAction.isEnabled ? 'wyłączyć' : 'włączyć'} DCC
                  </strong>{' '}
                  dla terminala{' '}
                  <strong>{dccAction.terminal?.tid}</strong>?
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setDccAction(null)}
                  >
                    Anuluj
                  </button>

                  <button
                    type="button"
                    className={
                      dccAction.isEnabled
                        ? 'btn btn-danger'
                        : 'btn btn-success'
                    }
                    onClick={saveTerminalDCC}
                  >
                    {dccAction.isEnabled ? 'Wyłącz DCC' : 'Włącz DCC'}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
      {paymentAction && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">{paymentAction.action === 'add' ? `Dodanie płatności ${getPaymentName(paymentAction.type)}` : `Usunięcie płatności ${getPaymentName(paymentAction.type)}`}</h5>
                  <button type="button" className="btn btn-link px-2 fas fa-times" onClick={() => setPaymentAction(null)}/>
                </div>
                <div className="modal-body">
                  <div className="border rounded p-3 bg-light">
                    <strong>Klient:</strong>{' '}{paymentAction?.terminal?.merchantName || '-'}<br/>
                    <strong>MID:</strong>{' '}{paymentAction?.terminal?.mid || '-'}<br/>
                    <strong>Terminal:</strong>{' '}{paymentAction?.terminal?.tid || '-'}<br/>
                    <strong>Processor TID:</strong>{' '}{paymentAction?.terminal?.processorTid || '-'}<br/>
                    <strong>Urządzenie SN:</strong>{' '}{paymentAction?.terminal?.sn || '-'}<br/>
                    <hr className="my-2" />
                    <strong>Typ płatności:</strong>{' '}<span className={paymentAction.type === 'blik' ? 'badge badge-danger' : 'badge badge-success'}>{getPaymentName(paymentAction.type)}</span><br/>
                    <strong>TID płatności:</strong>{' '}<span className={paymentAction.type === 'blik' ? 'badge badge-danger' : 'badge badge-success'}>{paymentAction.paymentTid || '-'}</span>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button variant="secondary" onClick={() => setPaymentAction(null)}>
                    Anuluj
                  </Button>
                  <Button variant={paymentAction.action === 'add' ? 'success' : 'danger'} onClick={() => savePaymentAction()}>
                    {paymentAction.action === 'add' ? 'Dodaj' : 'Usuń'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {showAddDeviceModal && <>
        <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.45)'}} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content border-0 shadow">
              <div className="modal-header">
                <h5 className="modal-title">Dodaj urządzenia</h5>
                <button type="button" className="btn btn-link px-2 fas fa-times" onClick={() => {setShowAddDeviceModal(false); setNewDevicesText('')}}/>
              </div>

              <div className="modal-body">
                <div className="form-group mb-2">
                  <label className="font-weight-bold">Numery SN — wpisz lub wklej</label>
                  <textarea className="form-control" rows="9" value={newDevicesText} onChange={e => setNewDevicesText(e.target.value.toUpperCase())}
                    placeholder={`N620W600006\nN620W600007\nN620W600008\nUN20W625039`}/>
                  <small className="text-muted">Jeden numer seryjny w jednej linii. Możesz wkleić bezpośrednio całą kolumnę z Excela.</small>
                </div>

                {!!parseDeviceSns().length && <div className="border rounded bg-light mt-3">
                  <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                    <strong>Do dodania</strong>
                    <span className="badge badge-primary">{parseDeviceSns().length}</span>
                  </div>

                  <div style={{maxHeight: '220px', overflowY: 'auto'}}>
                    {parseDeviceSns().map(sn => {
                      const data = getDeviceData(sn)

                      return (
                        <div key={sn} className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                          <span><i className="fas fa-mobile-alt mr-2 text-muted"/>{sn}</span>
                          <span className={`badge badge-${data.valid ? 'success' : 'danger'}`}>
                            {data.valid ? data.model : 'Niepoprawny SN'}
                          </span>
                        </div>
                      )
                    })}
                  </div>
                </div>}
              </div>

              <div className="modal-footer">
                <Button variant="secondary" onClick={() => {setShowAddDeviceModal(false); setNewDevicesText('')}}>Anuluj</Button>
                <Button variant="success" onClick={saveNewDevices} disabled={!parseDeviceSns().length}>
                  <i className="fas fa-plus mr-1"/>Dodaj urządzenia ({parseDeviceSns().length})
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"/>
      </>}
      {assignDeviceTerminal && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Połącz / odłącz urządzenie</h5>
                  <button type="button" className="btn btn-link px-2 fas fa-times" onClick={closeDeviceAssignmentModal}/>
                </div>

                <div className="modal-body">
                  <div className="border rounded p-3 bg-light mb-3">
                    <strong>Klient:</strong>{' '}{assignDeviceTerminal?.merchantName || '-'}<br/>
                    <strong>MID:</strong>{' '}{assignDeviceTerminal?.mid || '-'}<br/>
                    <strong>Terminal:</strong>{' '}{assignDeviceTerminal?.tid || '-'}<br/>
                    <strong>TViD:</strong>{' '}{assignDeviceTerminal?.processorTid || '-'}<br/>
                    <strong>Aktualne urządzenie SN:</strong>{' '}{getTerminalSn(assignDeviceTerminal) || '-'}
                    {assignDeviceTerminal?.bindSN && !assignDeviceTerminal?.sn && (
                      <><br/><small className="text-warning">Urządzenie pochodzi z BIND SN i również może zostać odłączone.</small></>
                    )}
                  </div>

                  <div className="d-flex align-items-center justify-content-center border rounded py-2 px-3 mb-3">
                    <span className={deviceAssignmentMode === 'auto' ? 'font-weight-bold text-primary' : 'text-muted'}>Automatyczne</span>
                    <div className="custom-control custom-switch mx-3">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="deviceAssignmentModeSwitch"
                        checked={deviceAssignmentMode === 'manual'}
                        onChange={e => changeDeviceAssignmentMode(e.target.checked)}
                      />
                      <label className="custom-control-label" htmlFor="deviceAssignmentModeSwitch" />
                    </div>
                    <span className={deviceAssignmentMode === 'manual' ? 'font-weight-bold text-primary' : 'text-muted'}>Manualne</span>
                  </div>

                  {deviceAssignmentMode === 'auto' ? (
                    getTerminalSn(assignDeviceTerminal) ? (
                      <div className="alert alert-warning mb-0">
                        Terminal ma przypisane urządzenie <strong>{getTerminalSn(assignDeviceTerminal)}</strong>. Tryb automatyczny wykona jego odłączenie.
                      </div>
                    ) : (
                      <div className="form-group mb-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <label className="font-weight-bold mb-0">Dostępne urządzenia</label>
                          <Button size="sm" variant="outline-success" onClick={() => {setShowAddDeviceModal(true); closeDeviceAssignmentModal()}}>
                            <i className="fas fa-plus mr-1"/>Dodaj urządzenie
                          </Button>
                        </div>
                        <select className="custom-select" value={selectedDeviceSn} onChange={e => setSelectedDeviceSn(e.target.value)}>
                          <option value="">Wybierz urządzenie</option>
                          {availableDevices.map(device => (
                            <option key={device?.sn} value={device?.sn}>
                              {device?.model + ' ' + device?.sn + ' ' + device?.type}
                            </option>
                          ))}
                        </select>
                        {availableDevices.length === 0 && <small className="text-danger d-block mt-2">Brak wolnych urządzeń do przypisania. Możesz przełączyć na tryb manualny.</small>}
                      </div>
                    )
                  ) : (
                    <>
                      <div className="form-group">
                        <label className="font-weight-bold d-block">Akcja</label>
                        <div className="btn-group btn-group-toggle w-100">
                          <Button
                            variant={manualDeviceAction === 'bind' ? 'success' : 'outline-success'}
                            onClick={() => changeManualDeviceAction('bind')}
                          >
                            <i className="fas fa-link mr-1"/>Połącz
                          </Button>
                          <Button
                            variant={manualDeviceAction === 'unbind' ? 'danger' : 'outline-danger'}
                            onClick={() => changeManualDeviceAction('unbind')}
                          >
                            <i className="fas fa-unlink mr-1"/>Odłącz
                          </Button>
                        </div>
                      </div>

                      <div className="form-group mb-0">
                        <label className="font-weight-bold">SN urządzenia</label>
                        <input
                          type="text"
                          className="form-control"
                          list="manualDeviceSnList"
                          value={manualDeviceSn}
                          onChange={e => setManualDeviceSn(e.target.value.toUpperCase().replace(/\s/g, ''))}
                          placeholder="Wpisz dowolny SN urządzenia..."
                          autoFocus
                        />
                        <datalist id="manualDeviceSnList">
                          {availableDevices.map(device => <option key={device?.sn} value={device?.sn}>{device?.model || ''}</option>)}
                          {getTerminalSn(assignDeviceTerminal) && <option value={getTerminalSn(assignDeviceTerminal)}>Aktualnie przypisane</option>}
                        </datalist>
                        <small className="text-muted d-block mt-1">Możesz wpisać SN ręcznie — urządzenie nie musi znajdować się na liście dostępnych urządzeń.</small>
                      </div>
                    </>
                  )}
                </div>

                <div className="modal-footer">
                  <Button variant="secondary" onClick={closeDeviceAssignmentModal}>Anuluj</Button>
                  <Button
                    variant={deviceAssignmentMode === 'manual' && manualDeviceAction === 'unbind' ? 'danger' : 'primary'}
                    onClick={saveDeviceAssignment}
                    disabled={deviceAssignmentMode === 'auto'
                      ? (!getTerminalSn(assignDeviceTerminal) && !selectedDeviceSn)
                      : !String(manualDeviceSn || '').trim()
                    }
                  >
                    {deviceAssignmentMode === 'auto'
                      ? (getTerminalSn(assignDeviceTerminal) ? 'Odłącz urządzenie' : 'Połącz urządzenie')
                      : (manualDeviceAction === 'bind' ? 'Połącz urządzenie' : 'Odłącz urządzenie')
                    }
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"/>
        </>
      )}
      {terminalHistoryProcessorTid && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1"role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Historia terminala {terminalHistoryProcessorTid}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => {setTerminalHistoryProcessorTid(null); setTerminalHistory([])}}/>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr className="text-center">
                          <th>Urządzenie</th>
                          <th>Status</th>
                          <th>Data</th>
                        </tr>
                      </thead>
                      <tbody>
                        {terminalHistory.map((t, i) => (
                          <tr key={i}>
                            <td className="text-center">{t?.dsn}</td>
                            <td className="text-center">{t?.status}</td>
                            <td className="text-center">{formatTs(t?.boundAt)}</td>
                          </tr>
                        ))}
                        {terminalHistory.length === 0 && (
                          <tr><td colSpan="3" className="text-center p-3">Brak historii terminala.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {deviceHistoryDSN && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1"role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Historia urządzenia {deviceHistoryDSN}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => {setDeviceHistoryDSN(null); setDeviceHistory([])}}/>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr className="text-center">
                          <th>Urządzenie</th>
                          <th>Terminal</th>
                          <th>Status</th>
                          <th>Data</th>
                        </tr>
                      </thead>
                      <tbody>
                        {deviceHistory.map((d, i) => (
                          <tr key={i}>
                            <td className="text-center">{d?.dsn}</td>
                            <td className="text-center">{d?.tid}</td>
                            <td className="text-center">{d?.status}</td>
                            <td className="text-center">{formatTs(d?.boundAt)}</td>
                          </tr>
                        ))}
                        {deviceHistory.length === 0 && (
                          <tr><td colSpan="3" className="text-center p-3">Brak historii urządzenia.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {showDevicesListModal && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Lista urządzeń ({devices.length})</h5>
                  <div className="d-flex align-items-center">
                    <Button size="sm" variant="success" className="mr-2" onClick={() => {setShowDevicesListModal(false); setShowAddDeviceModal(true)}}>
                      <i className="fas fa-plus mr-1" />Dodaj urządzenia
                    </Button>
                    <Button size="sm" variant="outline-primary" onClick={() => setShowDevicesListModal(false)}>
                      Zamknij
                    </Button>
                  </div>
                </div>

                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped mb-0">
                      <thead>
                        <tr className="text-center">
                          <th>SN</th>
                          <th>Model</th>
                          <th>Typ</th>
                          <th>Status</th>
                          <th>Terminal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {devices.map((device, index) => {
                          const terminal = terminals.find(t =>
                            String(getTerminalSn(t)) === String(device?.sn) &&
                            String(t?.tid || '').trim() !== ''
                          )
                          return (
                            <tr key={device?.sn || index}>
                              <td className="text-center align-middle">
                                <strong>{device?.sn || '-'}</strong>
                              </td>
                              <td className="text-center align-middle">
                                {device?.model || '-'}
                              </td>
                              <td className="text-center align-middle">
                                {device?.type || '-'}
                              </td>
                              <td className="text-center align-middle">
                                {terminal ? (
                                  <span className="badge badge-success">Przypisane</span>
                                ) : (
                                  <span className="badge badge-secondary">Wolne</span>
                                )}
                              </td>
                              <td className="text-center align-middle">
                                {terminal ? (
                                  <>
                                    <strong>TvID:</strong> {terminal?.processorTid || '-'}<br/>
                                    <small><strong>TID:</strong> {terminal?.tid || '-'}</small>
                                  </>
                                ) : '-'}
                              </td>
                            </tr>
                          )
                        })}

                        {devices.length === 0 && (
                          <tr>
                            <td colSpan="5" className="text-center p-3">
                              Brak urządzeń.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
      {configurationTerminal && (
        <>
          <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.45)'}} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Zmień konfigurację terminala {configurationTerminal?.tid}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => {setConfigurationTerminal(null); setSelectedConfiguration('')}}/>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <label>Konfiguracja</label>
                    <select className="form-control" value={selectedConfiguration} onChange={(e) => setSelectedConfiguration(e.target.value)}>
                      <option value="">-- wybierz konfigurację --</option>
                      {configurations.map((configuration) => (
                        <option key={configuration?.id || configuration?.name} value={configuration?.name}>{configuration?.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => {setConfigurationTerminal(null); setSelectedConfiguration('')}}>Anuluj</button>
                  <button type="button" className="btn btn-outline-primary" disabled={!selectedConfiguration} onClick={saveTerminalConfiguration}>Zmień konfigurację</button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}

      {showImportQueueModal && (
        <>
          <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.45)'}} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Kolejka importu Nexgo</h5>
                  <div className="d-flex align-items-center">
                    <Button size="sm" variant="outline-primary" className="mr-2" disabled={importQueueLoading} onClick={getImportQueue}>
                      <i className="fas fa-sync-alt mr-1"/>Odśwież z cache
                    </Button>
                    <button type="button" className="btn btn-link px-2 fas fa-times" onClick={() => setShowImportQueueModal(false)}/>
                  </div>
                </div>
                <div className="modal-body">
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
                    <span className="text-muted">Dane wyłącznie z cache. Brak automatycznego odpytywania UI.</span>
                    <span className="text-muted">
                      {importQueue.running ? 'Import w toku' : 'Import automatyczny co 10 minut'}
                      {importQueue.finishedAt ? ` · Ostatni przebieg: ${formatTs(importQueue.finishedAt)}` : ''}
                      {importQueue.nextRunAt ? ` · Następny: ${formatTs(importQueue.nextRunAt)}` : ''}
                    </span>
                  </div>
                  <div className="d-flex flex-wrap align-items-center mb-3">
                    <span className="badge badge-secondary mr-2 mb-1">Klienci: {importQueue.merchants || 0}</span>
                    <span className="badge badge-secondary mr-2 mb-1">Terminale: {importQueue.terminals || 0}</span>
                    <span className="badge badge-danger mr-3 mb-1">Błędy: {importQueue.errors || 0}</span>
                    <select className="form-control form-control-sm mb-1" style={{maxWidth: '210px'}} value={importQueueFilter} onChange={e => {setImportQueueFilter(e.target.value); setImportQueuePage(1);}}>
                      <option value="all">Wszystkie pozycje</option>
                      <option value="errors">Tylko błędy</option>
                      <option value="merchant">Klienci</option>
                      <option value="terminal">Terminale</option>
                      <option value="system">Błędy systemowe</option>
                    </select>
                  </div>
                  {importQueueLoading && <div className="small text-muted mb-2">Wczytywanie kolejki z cache...</div>}
                  <div className="table-responsive">
                    <table className="table table-striped table-sm mb-0">
                      <thead><tr className="text-center"><th>Typ</th><th>Processor ID</th><th>Klient / Processor MID</th><th>Status</th><th>Błąd</th><th>Próby</th><th>Akcja</th></tr></thead>
                      <tbody>
                        {visibleImportQueue.map((item, index) => (
                          <React.Fragment key={`${item.type}-${item.id}-${index}`}>
                            <tr>
                              <td className="text-center align-middle">{item.type === 'terminal' ? 'Terminal' : item.type === 'merchant' ? 'Klient' : 'System'}</td>
                              <td className="text-center align-middle text-nowrap">{item.id || '-'}</td>
                              <td className="align-middle">{item.name || item.processorMid || '-'}</td>
                              <td className="text-center align-middle"><span className={`badge badge-${item.matchedMerchantMid && /merchant not found/i.test(item.error || '') ? 'info' : item.error ? 'danger' : 'secondary'}`}>{item.matchedMerchantMid && /merchant not found/i.test(item.error || '') ? 'Ponowienie wkrótce' : item.error ? 'Błąd' : 'Oczekuje'}</span></td>
                              <td className={`align-middle ${item.error ? 'text-danger' : ''}`}>{item.error || '-'}{item.matchedMerchantMid && /merchant not found/i.test(item.error || '') && <div className="small text-success">Przypisano MID {item.matchedMerchantMid} ({item.matchedMerchantName}); następna próba automatyczna.</div>}</td>
                              <td className="text-center align-middle">{item.attempts || '-'}</td>
                              <td className="text-center align-middle">
                                {item.type === 'terminal' && item.processorMid && !item.matchedMerchantMid && /merchant not found/i.test(item.error || '') && (
                                  <Button size="sm" variant="outline-primary" disabled={assignMerchantSaving} onClick={() => {
                                    const opening = assignMerchantTerminalId !== item.id;
                                    setAssignMerchantTerminalId(opening ? item.id : null);
                                    setAssignMerchantMid('');
                                  }}>{assignMerchantTerminalId === item.id ? 'Zwiń' : 'Przypisz klienta'}</Button>
                                )}
                              </td>
                            </tr>
                            {item.type === 'terminal' && assignMerchantTerminalId === item.id && !item.matchedMerchantMid && /merchant not found/i.test(item.error || '') && (
                              <tr>
                                <td colSpan="7" className="p-3 bg-light">
                                  <div className="mb-2"><strong>Przypisz istniejącego klienta do Processor MID: {item.processorMid}</strong></div>
                                  <div className="mb-3">
                                    <label className="small font-weight-bold mb-1">Klienci bez przypisanego Processor MID ({(importQueue.availableMerchants || []).length})</label>
                                    <select className="form-control form-control-sm" value={assignMerchantMid} disabled={assignMerchantSaving} onChange={e => setAssignMerchantMid(e.target.value)}>
                                      <option value="">Wybierz merchanta...</option>
                                      {[...(importQueue.availableMerchants || [])].sort((a, b) => merchantAddressScore(item.address, b.address) - merchantAddressScore(item.address, a.address) || String(a.name).localeCompare(String(b.name), 'pl')).map(merchant => (
                                        <option key={merchant.mid} value={merchant.mid}>{merchant.mid} — {merchant.name}{merchant?.address?.city ? ` (${merchant.address.city})` : ''}</option>
                                      ))}
                                    </select>
                                    {(importQueue.availableMerchants || []).length === 0 && <small className="text-danger">Brak klientów z pustym Processor MID w aktualnym cache merchants.json.</small>}
                                  </div>
                                  <div className="row">
                                    <div className="col-md-6 mb-2">
                                      <div className="border rounded p-3 bg-white h-100">
                                        <strong>{item.addressSource === 'importMerchant' ? 'Adres klienta z importu' : 'Adres terminala z importu'}</strong>
                                        <div className="mt-2">{formatQueueAddress(item.address)}</div>
                                        <small className="text-muted">Processor TID: {item.id} · Processor MID: {item.processorMid}</small>
                                      </div>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                      <div className="border rounded p-3 bg-white h-100">
                                        <strong>Adres wybranego merchanta</strong>
                                        {(() => {
                                          const merchant = (importQueue.availableMerchants || []).find(m => String(m.mid) === String(assignMerchantMid));
                                          return merchant ? <>
                                            <div className="mt-2">{formatQueueAddress(merchant.address)}</div>
                                            <small className="text-muted">MID: {merchant.mid} · {merchant.name}{merchant.taxId ? ` · NIP: ${merchant.taxId}` : ''}</small>
                                          </> : <div className="mt-2 text-muted">Wybierz merchanta z listy.</div>;
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center flex-wrap mt-2">
                                    <small className="text-muted">Adresy są wskazówką, nie potwierdzeniem tożsamości klienta. Zweryfikuj wybór przed zapisem.</small>
                                    <Button size="sm" variant="primary" disabled={!assignMerchantMid || assignMerchantSaving} onClick={() => assignMerchantToQueueTerminal(item)}>
                                      {assignMerchantSaving ? 'Zapisywanie...' : 'Przypisz Processor MID'}
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                        {!importQueueLoading && visibleImportQueue.length === 0 && (
                          <tr><td colSpan="7" className="text-center p-4 text-muted">Brak pozycji w lokalnej kolejce.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {importQueuePages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <Button size="sm" variant="outline-secondary" disabled={importQueuePage <= 1} onClick={() => setImportQueuePage(page => Math.max(1, page - 1))}>Poprzednia</Button>
                      <span className="text-muted small">Strona {importQueuePage} / {importQueuePages} · {filteredImportQueue.length} pozycji</span>
                      <Button size="sm" variant="outline-secondary" disabled={importQueuePage >= importQueuePages} onClick={() => setImportQueuePage(page => Math.min(importQueuePages, page + 1))}>Następna</Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}

      {terminalDetails && terminalDetailsForm && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Dane terminala {terminalDetailsForm.tid}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={closeTerminalDetailsModal}/>
                </div>

                <div className="modal-body">
                  <h6 className="font-weight-bold mb-3">Terminal</h6>
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <label>TID</label>
                      <input className="form-control" value={terminalDetailsForm.tid ?? ''} disabled/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>MID</label>
                      <input className="form-control" value={terminalDetailsForm.mid ?? ''} disabled/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Processor TID</label>
                      <input className="form-control" value={terminalDetailsForm.processorTid ?? ''} disabled/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>SN urządzenia</label>
                      <input className="form-control" value={terminalDetailsForm.sn ?? ''} disabled/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Processor MID</label>
                      <input className="form-control" value={terminalDetailsForm.processorMid ?? ''} onChange={e => changeTerminalDetails('processorMid', e.target.value)}/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>MCC</label>
                      <input className="form-control" value={terminalDetailsForm.mcc ?? ''} onChange={e => changeTerminalDetails('mcc', e.target.value.replace(/\D/g, ''))}/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Currency Code</label>
                      <input className="form-control" value={terminalDetailsForm.currencyCode ?? ''} onChange={e => changeTerminalDetails('currencyCode', e.target.value.replace(/\D/g, ''))}/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Country Code</label>
                      <input className="form-control" value={terminalDetailsForm.countryCode ?? ''} onChange={e => changeTerminalDetails('countryCode', e.target.value.replace(/\D/g, ''))}/>
                    </div>
                  </div>

                  <hr/>

                  <h6 className="font-weight-bold mb-3">Adres</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>Ulica</label>
                      <input className="form-control" value={terminalDetailsForm.address?.street ?? ''} onChange={e => changeTerminalDetails('address.street', e.target.value)}/>
                    </div>
                    <div className="col-md-2 mb-3">
                      <label>Kod pocztowy</label>
                      <input className="form-control" value={terminalDetailsForm.address?.zipCode ?? ''} onChange={e => changeTerminalDetails('address.zipCode', e.target.value)}/>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Miasto</label>
                      <input className="form-control" value={terminalDetailsForm.address?.city ?? ''} onChange={e => changeTerminalDetails('address.city', e.target.value)}/>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Region / dzielnica</label>
                      <input className="form-control" value={terminalDetailsForm.address?.district ?? ''} onChange={e => changeTerminalDetails('address.district', e.target.value)}/>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Kraj</label>
                      <input className="form-control" value={terminalDetailsForm.address?.country ?? ''} onChange={e => changeTerminalDetails('address.country', e.target.value.toUpperCase())}/>
                    </div>
                  </div>

                  <hr/>

                  <h6 className="font-weight-bold mb-3">Płatności</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="border rounded p-3 h-100">
                        <div className="custom-control custom-switch mb-3">
                          <input type="checkbox" className="custom-control-input" id="terminal-details-cards" checked={terminalDetailsForm.auth?.cards?.enabled ?? false} onChange={e => changeTerminalDetails('auth.cards.enabled', e.target.checked)}/>
                          <label className="custom-control-label" htmlFor="terminal-details-cards">Karty</label>
                        </div>
                        <label>TID kart</label>
                        <input className="form-control" value={terminalDetailsForm.auth?.cards?.tid ?? ''} onChange={e => changeTerminalDetails('auth.cards.tid', e.target.value)}/>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border rounded p-3 h-100">
                        <div className="custom-control custom-switch mb-3">
                          <input type="checkbox" className="custom-control-input" id="terminal-details-blik" checked={terminalDetailsForm.auth?.blik?.enabled ?? false} onChange={e => changeTerminalDetails('auth.blik.enabled', e.target.checked)}/>
                          <label className="custom-control-label" htmlFor="terminal-details-blik">BLIK</label>
                        </div>
                        <label>TID BLIK</label>
                        <input className="form-control" value={terminalDetailsForm.auth?.blik?.tid ?? ''} onChange={e => changeTerminalDetails('auth.blik.tid', e.target.value)}/>
                      </div>
                    </div>
                  </div>

                  <hr/>

                  <h6 className="font-weight-bold mb-3">Hasła</h6>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>OTP</label>
                      <input className="form-control" value={terminalDetailsForm.otp ?? ''} onChange={e => changeTerminalDetails('otp', e.target.value.replace(/\D/g, ''))}/>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Admin</label>
                      <input className="form-control" value={terminalDetailsForm.adminPass ?? ''} onChange={e => changeTerminalDetails('adminPass', e.target.value.replace(/\D/g, ''))}/>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Tech</label>
                      <input className="form-control" value={terminalDetailsForm.techPass ?? ''} onChange={e => changeTerminalDetails('techPass', e.target.value.replace(/\D/g, ''))}/>
                    </div>
                  </div>

                  <hr/>

                  <h6 className="font-weight-bold mb-3">Informacje tylko do odczytu</h6>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>Status</label>
                      <input className="form-control" value={terminalDetails?.status?.status ?? terminalDetails?.status ?? ''} disabled/>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Konfiguracja żądana</label>
                      <input className="form-control" value={terminalDetails?.configuration?.requested?.name ?? ''} disabled/>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Konfiguracja zainstalowana</label>
                      <input className="form-control" value={terminalDetails?.configuration?.installed?.name ?? ''} disabled/>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <Button variant="secondary" onClick={closeTerminalDetailsModal} disabled={isSavingTerminalDetails}>Anuluj</Button>
                  <Button variant="primary" onClick={saveTerminalDetails} disabled={isSavingTerminalDetails}>
                    {isSavingTerminalDetails ? 'Zapisywanie...' : 'Zapisz'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}

      {deviceVerifyDSN && terminalVerifyProcessorTid && (
        <>
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1"role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Poprawność przypisania urządzenia {deviceVerifyDSN} do terminala {terminalVerifyProcessorTid}</h5>
                  <button type="button" className="btn btn-link fas fa-xmark" onClick={() => {setDeviceVerifyDSN(null); setTerminalVerifyProcessorTid(null); setIsDeviceBindToGoodTerminal({})}}/>
                </div>
                <div className="modal-body">
                  <div className="border rounded p-3 bg-light mb-3">
                    <strong>Urządzenie:</strong>{' '}{deviceVerifyDSN || '-'}<br/>
                    <strong>Terminal:</strong>{' '}{isDeviceBindToGoodTerminal?.tid || '-'}<br/>
                    <strong>Status:</strong>{' '}{isDeviceBindToGoodTerminal?.verified === true && "Powiązane"}{isDeviceBindToGoodTerminal?.verified === false && "Nie powiązane"}<br/>
                    {isDeviceBindToGoodTerminal?.verified === false && <><strong>Powód:</strong>{' '}{isDeviceBindToGoodTerminal?.reason}<br/></>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
    </>
  );
};

export default Nexgo;